var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _polygon, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _polygon2, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _polygon3, _path104, _path105, _path106, _path107, _path108, _path109, _polygon4, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _polygon5, _path122, _path123, _path124, _path125, _path126, _path127, _path128;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScaniaSymbol = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 95.003",
    enableBackground: "new 0 0 100 95.003",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundingbox"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 100,
    height: 95.003
  }))), /*#__PURE__*/React.createElement("g", {
    id: "blue_Kopie"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 24.9162,
    cy: 24.3836,
    r: 80.5503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#212A7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#202978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833,
    style: {
      stopColor: "#202977"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    style: {
      stopColor: "#1E2770"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#1C246A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2667,
    style: {
      stopColor: "#16215D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3333,
    style: {
      stopColor: "#141C52"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4133,
    style: {
      stopColor: "#12194B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#101745"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#0F1540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    style: {
      stopColor: "#0E143C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#0E143E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0F123C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M98.38,32.943c-2.202-9.727-7.29-18.625-14.728-25.502c-2.962,0.747-5.954,1.393-8.968,1.944 c-14.788-10.6-34.687-10.611-49.491,0c-3.014-0.55-6.006-1.196-8.968-1.943C8.806,14.299,3.704,23.189,1.496,32.943 c2.129,2.192,4.184,4.46,6.168,6.795C5.889,57.732,15.718,75.04,32.412,82.601c1.031,2.886,1.967,5.8,2.801,8.74 c9.293,2.885,19.545,3.075,29.449,0c0.834-2.94,1.77-5.854,2.801-8.74c16.718-7.572,26.52-24.895,24.748-42.863 C94.195,37.403,96.251,35.135,98.38,32.943z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "red_Kopie"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Griffin_1_",
    cx: 32.5374,
    cy: 24.2808,
    r: 55.4346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1882,
    style: {
      stopColor: "#E10016"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2837,
    style: {
      stopColor: "#E3001A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    style: {
      stopColor: "#E00015"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5557,
    style: {
      stopColor: "#DF0014"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6711,
    style: {
      stopColor: "#DD0015"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8166,
    style: {
      stopColor: "#D30216"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A91115"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Griffin_4_",
    fill: "url(#Griffin_1_)",
    d: "M68.515,61.034c-1.266-4.884-5.336-4.884-5.336-4.884 C70.324,67.274,59.471,72.7,59.471,72.7c0.995-6.602-3.798-8.23-3.798-8.23c3.436,14.47-8.604,14.738-8.604,14.738 c0.885-1.546,1.009-4.517,1.009-4.517c0.543-3.437-1.073-9.653-1.073-9.653c-2.884,2.408-2.884,10.214-2.884,10.214 C33.971,66.72,41.63,58.018,41.63,58.018c-2.687,0.664-5.129,3.603-5.129,3.603c-2.657-7.326,4.397-10.309,4.397-10.309 c-1.14,0.139-2.125,0.054-2.125,0.054c-5.899,0.086-5.723-4.3-5.723-4.3c2.995,0.945,4.85,1.933,8.096-0.128 c3.246-2.061,3.752-3.264,3.752-3.264c-0.172-0.796,0.253-1.551-3.513-2.537c-2.758-0.723-4.285-2.849-4.285-2.849 c-2.983-2.442-8.181,1.307-8.181,1.307c2.699-12.711,11.3-6.871,11.3-6.871c0.233-0.978,1.525-2.34,2.309-2.947l19.065,0.001 c1.443-0.635,3.172-1.038,5.12-0.819c0,0-0.804,3.578-3.486,6.182c0.079,0.153,0.207,0.285,0.405,0.388 c6.42,3.347,6.692,10.128,6.692,10.128c-1.99-2.984-5.608-2.079-5.608-2.079C74.304,52.08,68.515,61.034,68.515,61.034z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tongue_x2C__eye_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.1769,
    y1: 33.9091,
    x2: 42.9438,
    y2: 42.2647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E50026"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#E4001E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4001A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "tongue_x2C__eye_4_",
    fill: "url(#tongue_x2C__eye_1_)",
    d: "M39.906,43.919c0.635,0.093,0.464-0.355,0.385-0.668 c-0.095-0.376-1.015-0.989-1.386-1.101c-0.696-0.211-1.971-0.555-2.734-0.555c-0.434,0-1.804,0.255-2.12,0.337 c-1.615,0.411-3.225,0.62-4.786,0.62c-2.162,0-5.828-0.785-7.279-1.898c-0.16-0.123-0.646-0.092-0.908,0.241 c-0.216,0.273,0.133,0.63,0.334,0.914c0.405,0.568,1.541,1.717,1.873,2.007C28.425,48.157,32.682,42.863,39.906,43.919z  M40.37,33.691l0.906-0.477c1.874,0.64,3.26-0.562,5.41,0.051c0.213,0.061-0.145,0.793-0.339,1.328 C45.165,37.883,40.929,37.678,40.37,33.691z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "sides_hub"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.8516,
    y1: 4.1726,
    x2: 75.0926,
    y2: 4.2603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#696D67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0348,
    style: {
      stopColor: "#70746E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1104,
    style: {
      stopColor: "#797E77"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#7C817A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    style: {
      stopColor: "#7A7F78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5918,
    style: {
      stopColor: "#737872"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6765,
    style: {
      stopColor: "#686B67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7466,
    style: {
      stopColor: "#585A57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8072,
    style: {
      stopColor: "#424343"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#3D3D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#36373B"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M75.07,8.351c-0.053-0.01-0.104-0.031-0.149-0.063C59.949-2.187,40.035-2.174,25.081,8.287 c-0.043,0.03-0.091,0.051-0.142,0.062l-0.095-0.194l0.085-0.243C32.236,2.824,40.974,0.04,50,0.04s17.764,2.783,25.07,7.872 l0.016,0.234L75.07,8.351z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.0377,
    y1: 7.1338,
    x2: 84.1804,
    y2: 7.1338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414243"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0728,
    style: {
      stopColor: "#444647"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#484B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3301,
    style: {
      stopColor: "#4C4F4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#4F5250"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7685,
    style: {
      stopColor: "#4B4D4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3F4041"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M84.083,6.386c-2.93,0.753-5.888,1.407-8.87,1.965c-0.048,0.009-0.096,0.009-0.143,0l-0.032-0.229 l0.023-0.167l0.009-0.043c3.035-0.567,6.046-1.233,9.026-2.003l0.084,0.291L84.083,6.386z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.2192,
    y1: 5.2873,
    x2: 100.5981,
    y2: 33.0317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3F4040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#393A3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#333534"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#292D2D"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M99.535,33.161c-2.047-9.433-6.76-18.166-13.692-25.098c-0.575-0.575-1.162-1.133-1.761-1.677 l0.056-0.223l-0.053-0.209l0.011-0.045c0.683,0.613,1.353,1.244,2.005,1.896c7.056,7.056,11.829,15.965,13.855,25.582 l-0.325-0.034L99.535,33.161z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.2459,
    y1: 39.9423,
    x2: 99.9932,
    y2: 33.4265
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#313231"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0839,
    style: {
      stopColor: "#333537"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#34363A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#2F3132"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8148,
    style: {
      stopColor: "#2F302F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    style: {
      stopColor: "#2E2C25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C2617"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M93.323,39.994c0.016-0.048,0.041-0.094,0.075-0.133c1.975-2.303,4.021-4.538,6.138-6.699 l0.221,0.065l0.156,0.149l0.044,0.013c-2.157,2.197-4.24,4.472-6.249,6.817l-0.192,0.017L93.323,39.994z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.6459,
    y1: 85.5809,
    x2: 96.9554,
    y2: 42.0949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#181607"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0308,
    style: {
      stopColor: "#19180F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#1E2029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    style: {
      stopColor: "#1B1A1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2578,
    style: {
      stopColor: "#17110D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3365,
    style: {
      stopColor: "#150D03"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#140B00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5507,
    style: {
      stopColor: "#181107"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7158,
    style: {
      stopColor: "#22201C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8199,
    style: {
      stopColor: "#2B2C2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9253,
    style: {
      stopColor: "#323333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B3C3C"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M68.251,83.405c0.037-0.047,0.084-0.084,0.139-0.11c16.602-7.751,26.493-25.02,24.916-43.149 c-0.005-0.052,0.002-0.103,0.017-0.152l0.184,0.135l0.158,0.062l0.042,0.014c0.104,1.227,0.16,2.462,0.16,3.703 c0,11.634-4.622,22.792-12.848,31.018c-3.627,3.627-7.823,6.551-12.379,8.69l-0.288,0.048L68.251,83.405z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.5009,
    y1: 92.3735,
    x2: 68.5686,
    y2: 83.5146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#262928"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#262A2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#262827"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1E2029"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M65.456,92.181c0.813-2.914,1.726-5.803,2.733-8.664c0.014-0.041,0.035-0.079,0.062-0.112 l0.129,0.18l0.228,0.002l0.032,0.03c-1.026,2.912-1.955,5.852-2.779,8.819l-0.351-0.058L65.456,92.181z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1395,
    y1: 93.5715,
    x2: 65.8605,
    y2: 93.5715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#434546"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#3F3F40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4008,
    style: {
      stopColor: "#38393B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#303235"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    style: {
      stopColor: "#292B2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#212226"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8374,
    style: {
      stopColor: "#1C1C1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9528,
    style: {
      stopColor: "#100A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090100"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M34.544,92.181c10.062,3.222,20.841,3.225,30.912,0l0.166,0.16l0.206,0.062l0.033,0.032 C60.786,94.093,55.438,94.962,50,94.962c-5.438,0-10.786-0.869-15.86-2.528l0.202-0.227L34.544,92.181z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.331,
    y1: 92.376,
    x2: 31.5978,
    y2: 83.3801
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C4E4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0206,
    style: {
      stopColor: "#555957"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0515,
    style: {
      stopColor: "#5C615E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#5E6360"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#616461"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6481,
    style: {
      stopColor: "#6C716C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8354,
    style: {
      stopColor: "#787E78"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7C837C"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M31.723,83.375c0.039,0.04,0.069,0.088,0.088,0.142c1.007,2.861,1.921,5.75,2.733,8.664 l-0.166,0.16l-0.206,0.062l-0.033,0.032c-0.824-2.966-1.753-5.907-2.779-8.819l0.066-0.183L31.723,83.375z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.1418,
    y1: 85.4738,
    x2: 3.0596,
    y2: 42.0301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#646661"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0358,
    style: {
      stopColor: "#4D4F4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#434546"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#434546"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#434546"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#444647"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8134,
    style: {
      stopColor: "#464849"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#4F5250"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    style: {
      stopColor: "#565956"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#636661"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M6.673,39.982c0.018,0.052,0.026,0.107,0.021,0.163C5.111,58.338,15.067,75.571,31.61,83.295 c0.043,0.02,0.081,0.047,0.113,0.08l-0.198,0.104l-0.132,0.108l-0.032,0.03C15.93,76.373,6.133,60.875,6.133,43.907 c0-1.241,0.056-2.476,0.16-3.703l0.19-0.151L6.673,39.982z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.2525,
    y1: 33.15,
    x2: 6.4749,
    y2: 40.1584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404142"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0094,
    style: {
      stopColor: "#414243"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1089,
    style: {
      stopColor: "#4B4C4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#4E4F4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4468,
    style: {
      stopColor: "#5C5F5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#636661"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7677,
    style: {
      stopColor: "#696D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9879,
    style: {
      stopColor: "#7B827B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7C837C"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M0.464,33.161c2.117,2.161,4.163,4.397,6.138,6.699c0.031,0.036,0.055,0.078,0.071,0.122 l-0.18,0.146l-0.158,0.062l-0.042,0.014c-2.009-2.344-4.092-4.619-6.249-6.817l0.218-0.246L0.464,33.161z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.9107,
    y1: 32.8386,
    x2: 14.9044,
    y2: 5.3352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404142"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#464949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4649,
    style: {
      stopColor: "#5A5D5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#616461"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7777,
    style: {
      stopColor: "#696D68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70746E"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M0.464,33.161C2.697,22.873,8.076,13.509,15.917,6.386l0.094-0.185L15.903,5.91 c-0.683,0.613-1.353,1.244-2.005,1.896C6.843,14.861,2.069,23.77,0.044,33.388l0.044-0.013l0.156-0.149L0.464,33.161z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.844,
    y1: 6.1848,
    x2: 24.98,
    y2: 8.1601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C817A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0168,
    style: {
      stopColor: "#7F857F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0654,
    style: {
      stopColor: "#858B86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#868D88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    style: {
      stopColor: "#828983"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#7C837C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9444,
    style: {
      stopColor: "#7B827A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A8178"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M15.917,6.386c2.929,0.753,5.887,1.406,8.867,1.965c0.052,0.01,0.104,0.009,0.155-0.002 l-0.02-0.204l0.02-0.189L24.93,7.912c-3.035-0.567-6.046-1.233-9.026-2.003l0.011,0.045l-0.053,0.209L15.917,6.386z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.1523,
    y1: 11.4141,
    x2: 74.7071,
    y2: 11.4141
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9B0B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0261,
    style: {
      stopColor: "#B1B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0921,
    style: {
      stopColor: "#BEC3C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#C3C7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2576,
    style: {
      stopColor: "#BCC0BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    style: {
      stopColor: "#A7ABAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#A4A8A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5494,
    style: {
      stopColor: "#9DA2A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#8D9599"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8014,
    style: {
      stopColor: "#888F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9826,
    style: {
      stopColor: "#7B7D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#797B7B"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M25.295,10.01c0.077-0.015,0.157-0.016,0.236-0.002c16.192,2.909,32.721,2.913,48.936,0 c0.08-0.014,0.161-0.013,0.239,0.003l-0.029,0.194l-0.218,0.453c-8.02,1.434-16.201,2.173-24.46,2.173 c-8.259,0-16.44-0.739-24.46-2.173l-0.388-0.377L25.295,10.01z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.1525,
    y1: 38.501,
    x2: 75.63,
    y2: 9.4537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#969FA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0232,
    style: {
      stopColor: "#A1A9AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0752,
    style: {
      stopColor: "#B6BABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#BDC0BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C3C7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6454,
    style: {
      stopColor: "#D6DAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9367,
    style: {
      stopColor: "#DBDFDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9607,
    style: {
      stopColor: "#D4D8D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9786,
    style: {
      stopColor: "#C7CCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9934,
    style: {
      stopColor: "#B6BBBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ABB0B2"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M91.734,39.353c0.008-0.056,0.01-0.113,0.003-0.17c-1.303-11.519-7.321-22.075-16.78-29.061 c-0.075-0.056-0.161-0.093-0.251-0.112l-0.138,0.185l-0.095,0.412l-0.014,0.049c1.666,1.226,3.248,2.581,4.728,4.061 c6.66,6.66,10.806,15.363,11.835,24.635l0.429,0.172L91.734,39.353z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.8332,
    y1: 81.6019,
    x2: 90.5266,
    y2: 38.6586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDE0DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0779,
    style: {
      stopColor: "#D6D9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1941,
    style: {
      stopColor: "#C1C4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#BEC1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    style: {
      stopColor: "#C0C4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#C3C7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4566,
    style: {
      stopColor: "#D2D5D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5745,
    style: {
      stopColor: "#E2E5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#ECEEED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#EFF1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9429,
    style: {
      stopColor: "#EDEFEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9696,
    style: {
      stopColor: "#E6E8E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9894,
    style: {
      stopColor: "#DADDDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0D3D0"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M67.007,82.249c0.051-0.059,0.092-0.128,0.119-0.203c2.763-7.666,6.212-15.124,10.342-22.278 c4.13-7.153,8.863-13.868,14.12-20.093c0.078-0.092,0.128-0.204,0.146-0.322l-0.203,0.013h-0.458l-0.05-0.012 c-5.25,6.227-9.981,12.942-14.109,20.093c-4.129,7.151-7.579,14.605-10.347,22.266l0.246,0.452L67.007,82.249z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.0095,
    y1: 83.8137,
    x2: 67.0074,
    y2: 83.8137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A8ABAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3306,
    style: {
      stopColor: "#AEB2B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#AFB4B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7386,
    style: {
      stopColor: "#B6BABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#B7BABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8454,
    style: {
      stopColor: "#C9CAC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#D0D1CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9651,
    style: {
      stopColor: "#D6D8D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDE0DD"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M33.009,82.268c0.059,0.063,0.132,0.115,0.213,0.15c10.408,4.534,22.567,4.787,33.555,0 c0.089-0.039,0.167-0.097,0.23-0.169l-0.122-0.165l-0.283-0.333l-0.035-0.038C61.393,83.981,55.759,85.186,50,85.186 c-5.759,0-11.393-1.205-16.568-3.473l-0.371,0.268L33.009,82.268z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.1668,
    y1: 81.6021,
    x2: 9.4733,
    y2: 38.6586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4D5354"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    style: {
      stopColor: "#545A5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#5B6061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2715,
    style: {
      stopColor: "#5D6263"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5999,
    style: {
      stopColor: "#727676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#797D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8994,
    style: {
      stopColor: "#767A7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9597,
    style: {
      stopColor: "#6D7170"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#636765"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M8.265,39.353c0.018,0.117,0.068,0.229,0.146,0.321C19.023,52.24,27.289,66.549,32.873,82.045 c0.03,0.083,0.077,0.159,0.136,0.222l0.142-0.136l0.245-0.381l0.035-0.038c-2.768-7.661-6.218-15.115-10.347-22.266 c-4.129-7.151-8.859-13.866-14.109-20.094l-0.523-0.085L8.265,39.353z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.0146,
    y1: 38.6341,
    x2: 23.9268,
    y2: 9.2229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6D706E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0135,
    style: {
      stopColor: "#6D706F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#717576"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#80838A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8175,
    style: {
      stopColor: "#828791"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#858C99"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M8.265,39.353c-0.008-0.056-0.01-0.113-0.003-0.17c1.303-11.519,7.321-22.075,16.78-29.062 c0.076-0.056,0.162-0.094,0.253-0.112v0.202l0.23,0.397l0.014,0.049c-1.666,1.226-3.248,2.581-4.728,4.061 c-6.66,6.66-10.806,15.363-11.835,24.635l-0.05,0.012H8.468L8.265,39.353z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.5275,
    y1: 82.3028,
    x2: 5.6403,
    y2: 44.0855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FA3A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0641,
    style: {
      stopColor: "#989C9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1595,
    style: {
      stopColor: "#868A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#717574"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3153,
    style: {
      stopColor: "#727676"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#797D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9427,
    style: {
      stopColor: "#767A7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#717576"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M30.387,80.653c-0.172,0.15-0.419,0.177-0.619,0.067C15.878,73.087,7.664,58.423,8.003,43.037 c0.004-0.186,0.102-0.354,0.255-0.451l0.377,0.127l0.096,0.413c-0.005,0.26-0.01,0.52-0.01,0.78 c0,10.948,4.349,21.447,12.09,29.188c2.762,2.762,5.876,5.089,9.235,6.944l0.309,0.311L30.387,80.653z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.1619,
    y1: 80.2092,
    x2: 9.2796,
    y2: 42.0006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3F5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#F9FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F6F7F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F4F6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9824,
    style: {
      stopColor: "#F2F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0F3F3"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M8.258,42.586c0.036-0.023,0.074-0.041,0.115-0.055c0.217-0.074,0.458-0.005,0.603,0.173 c8.823,10.865,16.21,23.349,21.562,37.344c0.081,0.213,0.021,0.454-0.151,0.604l-0.134-0.148l-0.124-0.364l-0.083-0.101 c-2.543-6.622-5.613-13.076-9.204-19.296c-3.591-6.22-7.647-12.104-12.111-17.616l-0.047-0.124l-0.251-0.282L8.258,42.586z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.0057,
    y1: 90.8827,
    x2: 34.1846,
    y2: 84.6146
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1835,
    style: {
      stopColor: "#6D7273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4447,
    style: {
      stopColor: "#818588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#888C8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9102,
    style: {
      stopColor: "#85898C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#838789"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M35.814,90.92c-0.068-0.072-0.119-0.161-0.147-0.259c-0.457-1.586-1.067-3.563-1.719-5.518 c-0.058-0.175-0.011-0.368,0.122-0.495l0.315,0.07l0.177,0.247c0.599,1.795,1.164,3.6,1.688,5.415l-0.191,0.488L35.814,90.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.0703,
    y1: 86.1446,
    x2: 65.9158,
    y2: 86.1446
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0067,
    style: {
      stopColor: "#EFF2F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    style: {
      stopColor: "#E1E5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2388,
    style: {
      stopColor: "#D6DAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3711,
    style: {
      stopColor: "#C1C5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#B4B8B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4884,
    style: {
      stopColor: "#ADB1B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5608,
    style: {
      stopColor: "#9A9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    style: {
      stopColor: "#7A7E7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#6D706E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6C6F6D"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M65.916,84.637c-0.133-0.118-0.321-0.154-0.488-0.09c-9.629,3.656-20.598,3.895-30.858-0.001 c-0.172-0.065-0.367-0.026-0.5,0.102l0.139,0.146l0.282,0.101l0.071,0.07c4.89,1.839,10.113,2.809,15.438,2.809 c5.325,0,10.548-0.971,15.438-2.809l0.4-0.11L65.916,84.637z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.8655,
    y1: 90.8097,
    x2: 65.9615,
    y2: 84.6528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDE0DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1005,
    style: {
      stopColor: "#D6D9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#C3C7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3381,
    style: {
      stopColor: "#D2D5D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    style: {
      stopColor: "#E2E5E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6579,
    style: {
      stopColor: "#ECEEED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#EFF1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9429,
    style: {
      stopColor: "#EDEFEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9696,
    style: {
      stopColor: "#E6E8E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9894,
    style: {
      stopColor: "#DADDDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0D3D0"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M64.188,90.918c0.066-0.072,0.117-0.159,0.144-0.256c0.612-2.127,1.137-3.778,1.718-5.516 c0.059-0.175,0.011-0.368-0.122-0.496c-0.004-0.004-0.008-0.008-0.013-0.012l-0.125,0.156l-0.282,0.101l-0.071,0.07 c-0.599,1.795-1.164,3.6-1.688,5.415l0.223,0.467L64.188,90.918z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.8143,
    y1: 91.7409,
    x2: 64.1883,
    y2: 91.7409
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7ABAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3075,
    style: {
      stopColor: "#AEB2B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#B0B5B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#B4B8B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7612,
    style: {
      stopColor: "#B4B8B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8503,
    style: {
      stopColor: "#C9CBCA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#D0D2D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#D7D9D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDE0DD"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_25_)",
    d: "M64.188,90.918c-0.077,0.083-0.176,0.146-0.289,0.179c-9.071,2.672-18.718,2.675-27.799,0 c-0.111-0.033-0.209-0.094-0.286-0.177l0.128-0.152l0.275-0.348l0.033-0.041c4.425,1.309,9.052,1.994,13.75,1.994 c4.698,0,9.325-0.685,13.75-1.994l0.036,0.04l0.27,0.35L64.188,90.918z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.7022,
    y1: 80.1223,
    x2: 90.8507,
    y2: 42.0674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#848A8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#80838A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#6D706E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686B6B"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_26_)",
    d: "M91.647,42.531c-0.006-0.002-0.012-0.004-0.018-0.006c-0.216-0.074-0.454-0.005-0.598,0.172 c-4.525,5.572-8.635,11.523-12.269,17.818c-3.636,6.297-6.737,12.833-9.301,19.54c-0.079,0.206-0.025,0.438,0.134,0.588 l0.212-0.091l0.147-0.512c2.543-6.622,5.613-13.076,9.204-19.296c3.591-6.22,7.647-12.104,12.111-17.616l0.407-0.353 L91.647,42.531z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.4898,
    y1: 82.3237,
    x2: 94.4495,
    y2: 44.1346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C3C7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0257,
    style: {
      stopColor: "#C7CBC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#E6EAE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4082,
    style: {
      stopColor: "#DFE3E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#D0D3D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    style: {
      stopColor: "#C9CCCA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#C3C7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8742,
    style: {
      stopColor: "#BCC0BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    style: {
      stopColor: "#A7ADAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#999FA2"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_27_)",
    d: "M69.594,80.642c0.005,0.005,0.01,0.01,0.016,0.014c0.171,0.149,0.418,0.176,0.617,0.067 c13.924-7.649,22.112-22.343,21.77-37.696c-0.005-0.222-0.144-0.417-0.35-0.496l-0.078,0.183l-0.253,0.29l-0.047,0.124 c0.005,0.26,0.01,0.52,0.01,0.78c0,10.948-4.349,21.447-12.09,29.188c-2.762,2.762-5.876,5.089-9.235,6.944l-0.083,0.101 l-0.127,0.367L69.594,80.642z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.3408,
    y1: 9.7632,
    x2: 83.7181,
    y2: 8.396
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#686B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0853,
    style: {
      stopColor: "#717477"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2617,
    style: {
      stopColor: "#7F838C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#848993"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5225,
    style: {
      stopColor: "#888E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#8D9599"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7497,
    style: {
      stopColor: "#949C9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9431,
    style: {
      stopColor: "#A9AEB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B0B5B6"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_28_)",
    d: "M77.33,9.714c0.052-0.165,0.189-0.29,0.36-0.325c1.795-0.366,3.487-0.737,5.633-1.27 c0.112-0.028,0.229-0.024,0.337,0.008l-0.029,0.196l-0.256,0.44c-1.834,0.453-3.679,0.867-5.533,1.246l-0.312-0.044L77.33,9.714z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.2849,
    y1: 32.3806,
    x2: 84.432,
    y2: 7.6949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#919499"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0183,
    style: {
      stopColor: "#999CA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0732,
    style: {
      stopColor: "#ADB1B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#B4B8B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#C3C7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5546,
    style: {
      stopColor: "#CACECC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9108,
    style: {
      stopColor: "#D6DAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9566,
    style: {
      stopColor: "#C1C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A8AEB0"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_29_)",
    d: "M83.661,8.128c0.094,0.028,0.181,0.078,0.254,0.147c6.686,6.338,11.633,14.691,13.901,24.08 c0.023,0.096,0.023,0.194,0.002,0.288l-0.262,0.112l-0.435-0.175c-2.071-8.616-6.481-16.575-12.85-22.944 c-0.295-0.295-0.594-0.585-0.895-0.872l0.016-0.051l0.161-0.409L83.661,8.128z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.2336,
    y1: 37.3226,
    x2: 97.6135,
    y2: 32.4582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D3D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    style: {
      stopColor: "#D3D6D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1166,
    style: {
      stopColor: "#E3E5E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2304,
    style: {
      stopColor: "#ECEEED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#EFF1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4349,
    style: {
      stopColor: "#E5E8E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    style: {
      stopColor: "#DFE2DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7554,
    style: {
      stopColor: "#DDE0DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#DADDDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9394,
    style: {
      stopColor: "#D0D4D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C3C7C5"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_30_)",
    d: "M97.818,32.642c-0.025,0.112-0.08,0.217-0.162,0.302c-1.145,1.189-2.552,2.707-3.92,4.249 c-0.122,0.138-0.313,0.193-0.49,0.142l-0.109-0.335l0.139-0.25c1.255-1.416,2.536-2.807,3.845-4.169l0.053,0.012l0.451,0.014 L97.818,32.642z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.4759,
    y1: 36.6302,
    x2: 78.6336,
    y2: 8.9679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4D5354"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1128,
    style: {
      stopColor: "#545A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#636765"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3851,
    style: {
      stopColor: "#707473"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6454,
    style: {
      stopColor: "#828688"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#888C8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8675,
    style: {
      stopColor: "#868A8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9036,
    style: {
      stopColor: "#818382"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    style: {
      stopColor: "#787772"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    style: {
      stopColor: "#6B665B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9945,
    style: {
      stopColor: "#5B513E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#574C37"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_31_)",
    d: "M77.33,9.714c-0.003,0.009-0.005,0.019-0.008,0.028c-0.044,0.179,0.019,0.367,0.162,0.484 c8.272,6.75,13.731,16.272,15.425,26.726c0.029,0.182,0.161,0.331,0.338,0.382l0.059-0.195l-0.055-0.293l0.025-0.097 c-1.485-8.979-5.738-17.34-12.257-23.86c-1.015-1.015-2.076-1.975-3.176-2.879l-0.096-0.027l-0.23-0.192L77.33,9.714z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.9813,
    y1: 9.5543,
    x2: 71.9972,
    y2: 9.5543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9FA5A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1165,
    style: {
      stopColor: "#A6ACAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#B4B9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3563,
    style: {
      stopColor: "#BBC0BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5297,
    style: {
      stopColor: "#D0D3D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#DDE0DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    style: {
      stopColor: "#E3E6E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#E9ECEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#E3E6E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDE0DD"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_32_)",
    d: "M27.981,8.498c0.002,0.017,0.004,0.035,0.008,0.052c0.044,0.225,0.224,0.399,0.45,0.435 c13.854,2.211,28.367,2.355,43.123,0c0.207-0.033,0.374-0.181,0.435-0.378L71.816,8.52l-0.497,0.042 C64.311,9.671,57.185,10.24,50,10.24c-7.185,0-14.311-0.569-21.319-1.678l-0.505-0.151L27.981,8.498z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.9788,
    y1: 5.2485,
    x2: 72.0217,
    y2: 5.2485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C9195"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0528,
    style: {
      stopColor: "#989C9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#9FA3A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1782,
    style: {
      stopColor: "#A3A9AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#A9B0B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4655,
    style: {
      stopColor: "#B0B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6823,
    style: {
      stopColor: "#C5CAC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#DDE0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    style: {
      stopColor: "#DDE0DD"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M27.981,8.498c-0.02-0.208,0.08-0.411,0.261-0.521c14.075-8.523,30.8-7.701,43.516,0.001 c0.196,0.119,0.297,0.347,0.253,0.572c-0.004,0.019-0.009,0.038-0.014,0.057l-0.214-0.001l-0.337-0.022l-0.128-0.022 C64.938,4.713,57.577,2.629,50,2.629c-7.577,0-14.938,2.084-21.319,5.933l-0.128,0.022l-0.371-0.077L27.981,8.498z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.2758,
    y1: 8.2806,
    x2: 22.6503,
    y2: 9.8699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9B0B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1685,
    style: {
      stopColor: "#BCC0C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#C3C7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    style: {
      stopColor: "#B7BABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#A8ABAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8128,
    style: {
      stopColor: "#A5A8AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9137,
    style: {
      stopColor: "#9B9FA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C9195"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M22.682,9.741c-0.044-0.177-0.186-0.314-0.365-0.35c-1.798-0.366-3.495-0.738-5.642-1.271 c-0.11-0.027-0.223-0.024-0.329,0.006l-0.099,0.266l0.376,0.372c1.834,0.453,3.679,0.867,5.533,1.246l0.297-0.012L22.682,9.741z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.4349,
    y1: 36.5668,
    x2: 21.4614,
    y2: 9.0304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9DA3A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0134,
    style: {
      stopColor: "#A3A9AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957,
    style: {
      stopColor: "#C4C9C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1642,
    style: {
      stopColor: "#D9DCDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#E0E3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    style: {
      stopColor: "#E5E8E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2959,
    style: {
      stopColor: "#EDF0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#F0F3F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F0F2F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFF1EF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M6.753,37.334c0.177-0.051,0.308-0.2,0.338-0.382c1.68-10.368,7.086-19.925,15.431-26.732 c0.142-0.116,0.204-0.302,0.16-0.48l-0.195,0.048l-0.234,0.193l-0.096,0.027c-1.1,0.904-2.16,1.864-3.176,2.879 c-6.519,6.519-10.772,14.88-12.257,23.86L6.616,37.15L6.753,37.334z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.7339,
    y1: 37.351,
    x2: 2.4164,
    y2: 32.4365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E6169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0946,
    style: {
      stopColor: "#72777D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1991,
    style: {
      stopColor: "#81878C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3161,
    style: {
      stopColor: "#8A9194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#8D9497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      stopColor: "#8D9396"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#888C8F"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M6.753,37.334c-0.177,0.051-0.367-0.004-0.49-0.141c-1.367-1.542-2.774-3.059-3.919-4.248 c-0.082-0.085-0.137-0.19-0.162-0.302l0.18-0.151l0.517,0.088c1.31,1.361,2.59,2.753,3.845,4.169l0.025,0.097l0.006,0.267 L6.753,37.334z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.5282,
    y1: 32.2668,
    x2: 15.6429,
    y2: 7.7205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#686B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0932,
    style: {
      stopColor: "#6F7273"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#75797A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#848993"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7742,
    style: {
      stopColor: "#8B9098"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#969CA1"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_37_)",
    d: "M2.182,32.643c-0.021-0.094-0.021-0.193,0.002-0.289c2.268-9.385,7.212-17.738,13.901-24.079 c0.075-0.071,0.165-0.122,0.262-0.149l0.058,0.187l0.203,0.4l0.016,0.051c-0.302,0.287-0.6,0.577-0.896,0.872 C9.36,16.005,4.95,23.964,2.879,32.58l-0.053,0.012l-0.442,0.046L2.182,32.643z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "sides_griffin_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.79,
    y1: 32.4296,
    x2: 43.0955,
    y2: 29.6228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#918F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1657,
    style: {
      stopColor: "#95918C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4742,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6651,
    style: {
      stopColor: "#9B9890"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9498,
    style: {
      stopColor: "#A7A7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAAAA9"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M40.688,32.346c-0.024-0.094-0.011-0.193,0.039-0.277c0.687-1.165,2.029-2.289,2.417-2.407 l0.116,0.227l-0.021,0.101c-0.414,0.255-0.757,0.523-1.049,0.817c-0.354,0.33-0.912,0.977-1.169,1.437l-0.083,0.075L40.688,32.346 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.0379,
    y1: 33.9327,
    x2: 54.7894,
    y2: 25.7133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#928E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    style: {
      stopColor: "#918A80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B8379"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M59.786,29.858c-0.121-0.237-0.365-0.2-0.632-0.21c-0.084,0-15.929-0.01-16.009,0.015l0.072,0.232 l0.022,0.069v0.027c0.004-0.002,0.008-0.004,0.012-0.004c0.082,0,1.184,0,15.904,0.001L59.464,30 c0.01,0.001,0.02,0.008,0.022,0.018h0.096L59.786,29.858z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.4305,
    y1: 32.8003,
    x2: 59.8137,
    y2: 29.8904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AEB0AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2563,
    style: {
      stopColor: "#AFB1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M56.872,32.701c0.42-0.472,1.385-1.467,2.787-2.371c0.157-0.101,0.212-0.306,0.126-0.472 l-0.207,0.134l-0.07,0.019l-0.022,0.007c0.003,0.01-0.001,0.021-0.01,0.027c-1.832,1.182-2.942,2.521-3.09,2.705l0.166,0.009 L56.872,32.701z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.5016,
    y1: 32.6114,
    x2: 57.3431,
    y2: 33.315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#918F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1657,
    style: {
      stopColor: "#95918C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4742,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6651,
    style: {
      stopColor: "#9B9890"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9498,
    style: {
      stopColor: "#A7A7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAAAA9"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_41_)",
    points: "57.194,32.956 56.872,32.701 56.522,32.735 56.419,32.745 56.386,32.749 57.247,33.43  57.261,33.255  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.9547,
    y1: 32.8155,
    x2: 66.2637,
    y2: 28.3953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B3B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5703,
    style: {
      stopColor: "#B0B1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7646,
    style: {
      stopColor: "#A29F98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    style: {
      stopColor: "#98938A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAAAA9"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M66.571,29.043c-0.069-0.095-0.178-0.152-0.296-0.152h-0.613c-3.112,0-6.324,1.55-8.469,4.066 l0.035,0.337l0.011,0.102l0.007,0.035c2.064-2.583,5.292-4.2,8.417-4.2c0.02,0,0.62-0.006,0.632,0.01l0.094-0.022L66.571,29.043z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.1474,
    y1: 37.8248,
    x2: 67.2374,
    y2: 29.7065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AEB0AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    style: {
      stopColor: "#AFB1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M59.004,37.524c4.809-1.263,6.786-5.694,7.419-7.573l0.196-0.58 c0.038-0.111,0.019-0.234-0.049-0.329c-0.034,0.025-0.243,0.173-0.275,0.198c0.012,0.017-0.199,0.621-0.193,0.602 c-0.63,1.867-2.619,6.322-7.496,7.429l0.126,0.14L59.004,37.524z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.7737,
    y1: 37.2383,
    x2: 58.9929,
    y2: 38.3157
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4B6B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_44_)",
    d: "M59.091,37.947l-0.087-0.423l-0.285-0.179l-0.086-0.055l-0.027-0.018 c0.005,0.022,0.01,0.047,0.014,0.068c0.003,0.012,0.208,1.009,0.208,1.009l0.122-0.124L59.091,37.947z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.7915,
    y1: 38.2697,
    x2: 63.5021,
    y2: 36.053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0504,
    style: {
      stopColor: "#8D867D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#9B9C9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6213,
    style: {
      stopColor: "#A2A3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8469,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_45_)",
    d: "M63.339,35.707c-0.058,0.013-0.112,0.04-0.159,0.081c-1.008,0.877-2.201,1.739-4.089,2.16 l-0.188,0.288l-0.057,0.085l-0.017,0.029c2.155-0.406,3.464-1.343,4.576-2.305c0.003-0.002,0.005-0.005,0.011-0.006 c0.006-0.002,0.01,0.002,0.013,0.003l0.008-0.099L63.339,35.707z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.3896,
    y1: 43.7678,
    x2: 63.5511,
    y2: 35.5308
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8F9096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2103,
    style: {
      stopColor: "#A7A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#B4B5B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_46_)",
    d: "M69.632,44.382c0.151-0.072,0.234-0.238,0.2-0.402c-0.75-3.666-2.574-6.45-6.253-8.246 c-0.076-0.037-0.161-0.046-0.239-0.028c0.027,0.112,0.048,0.206,0.08,0.307l0.01,0.027c3.158,1.541,5.204,4.086,5.928,7.353 l0.021,0.093c0.031,0.135,0.081,0.356,0.123,0.562c0.002,0.011-0.003,0.022-0.013,0.027l0.004,0.098L69.632,44.382z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.6756,
    y1: 43.7631,
    x2: 63.5399,
    y2: 43.3341
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0796,
    style: {
      stopColor: "#96918A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    style: {
      stopColor: "#B0B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_47_)",
    d: "M64.24,43.414c2.362-0.576,4.326,0.108,4.954,0.87c0.106,0.129,0.286,0.17,0.438,0.097 l-0.104-0.219l-0.031-0.066l-0.009-0.022c-0.003,0.002-0.007,0.002-0.01,0.002c-0.007,0-0.014-0.003-0.019-0.009 c-0.122-0.147-0.38-0.36-0.468-0.414c-0.86-0.531-1.863-0.8-2.982-0.8c-1.064,0-1.985,0.249-2.464,0.407l0.236,0.076L64.24,43.414 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.4066,
    y1: 59.4427,
    x2: 64.8763,
    y2: 42.8179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8F9096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2103,
    style: {
      stopColor: "#A7A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#B4B5B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_48_)",
    d: "M64.24,43.414c3.541,3.107,5.818,6.273,5.818,11.146c0,1.728-0.308,3.316-0.916,4.719 c-0.062,0.142-0.163,0.376-0.206,0.502c-0.051,0.147-0.189,0.245-0.344,0.245l-0.043-0.251l0.044-0.089 c0.01,0,0.02-0.006,0.023-0.016c0.045-0.132,0.151-0.377,0.216-0.526c0.589-1.361,0.888-2.903,0.888-4.584 c0-1.581-0.245-3.012-0.75-4.375c-0.668-1.803-1.777-3.441-3.49-5.154c-0.553-0.553-1.169-1.117-1.934-1.771l0.047,0.009 l0.147,0.03L64.24,43.414z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.0582,
    y1: 59.1413,
    x2: 62.1782,
    y2: 55.5139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0796,
    style: {
      stopColor: "#96918A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    style: {
      stopColor: "#B0B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_49_)",
    d: "M62.754,55.87c2.323-0.04,4.211,1.071,5.324,3.426c0.075,0.16,0.132,0.338,0.159,0.452 c0.039,0.162,0.184,0.278,0.354,0.278c-0.002-0.092-0.011-0.263,0.002-0.34c-0.011,0-0.021-0.008-0.023-0.018 c-0.041-0.169-0.109-0.362-0.183-0.517c-1.416-2.994-3.778-3.622-5.51-3.622c-0.233,0-0.463,0.011-0.724,0.033l0.205,0.14 L62.754,55.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.25,
    y1: 72.2342,
    x2: 63.7253,
    y2: 55.7035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8F9096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2103,
    style: {
      stopColor: "#A7A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#B4B5B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_50_)",
    d: "M59.866,71.965c0.131,0.1,0.31,0.098,0.44,0.001c0.059-0.044,0.325-0.231,0.404-0.285 c1.636-1.11,3.262-2.907,4.079-5.015c1.482-3.826,0.138-7.405-2.035-10.795l-0.433-0.224l-0.128-0.063l-0.041-0.02 c1.16,1.787,2.915,4.49,2.915,7.811c0,1.086-0.199,2.152-0.593,3.169c-0.488,1.259-1.262,2.424-2.301,3.463 c-0.464,0.464-0.908,0.889-1.652,1.394c-0.083,0.056-0.358,0.249-0.419,0.295c-0.004,0.003-0.009,0.005-0.014,0.005 c-0.005,0-0.01-0.001-0.015-0.005l-0.081,0.057L59.866,71.965z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.8335,
    y1: 71.2748,
    x2: 55.2037,
    y2: 63.3821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0796,
    style: {
      stopColor: "#96918A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    style: {
      stopColor: "#B0B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_51_)",
    d: "M55.379,64.106c2.796,1.041,4.516,3.744,4.429,7.057c-0.003,0.12-0.038,0.321-0.061,0.379 c-0.06,0.152-0.011,0.325,0.119,0.423l0.147-0.193l0.044-0.058l0.016-0.019c-0.009-0.007-0.012-0.018-0.008-0.028 c0.044-0.11,0.08-0.352,0.084-0.494c0.097-3.693-1.96-6.663-5.244-7.577l0.154,0.224L55.379,64.106z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.8929,
    y1: 79.7984,
    x2: 56.5117,
    y2: 64.2807
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002057668,
    style: {
      stopColor: "#8F9096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2103,
    style: {
      stopColor: "#A7A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.889,
    style: {
      stopColor: "#B4B5B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_52_)",
    d: "M47.579,78.733c0.074,0.126,0.218,0.201,0.373,0.176c1-0.163,1.831-0.306,3.272-1.022 c5.186-2.577,5.537-8.13,4.155-13.78l-0.341-0.371l-0.101-0.106l-0.032-0.034l0.068,0.278c0.363,1.472,0.773,3.138,0.773,5.389 c0,2.433-0.604,4.451-1.795,5.999c-0.736,0.957-1.704,1.738-2.877,2.321c-0.975,0.485-1.815,0.768-2.725,0.917 c0,0-0.453,0.074-0.454,0.074c-0.009,0-0.017-0.004-0.021-0.012l-0.099,0.014L47.579,78.733z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.337,
    y1: 78.6933,
    x2: 47.5678,
    y2: 64.0167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0796,
    style: {
      stopColor: "#96918A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    style: {
      stopColor: "#B0B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_53_)",
    d: "M47.12,64.623c0.522,1.921,1.351,5.047,1.351,8.44c0,1.259-0.239,4.28-0.867,5.265 c-0.089,0.117-0.099,0.276-0.025,0.404l0.21-0.122l0.063-0.037l0.022-0.012c-0.005-0.009-0.004-0.019,0.002-0.027 c0.041-0.051,0.126-0.236,0.172-0.336c0.105-0.229,0.18-0.487,0.235-0.689c0.515-1.898,0.53-4.19,0.53-4.446 c0-3.518-0.876-6.738-1.399-8.662l-0.1-0.372l-0.115,0.21L47.12,64.623z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.0768,
    y1: 74.1708,
    x2: 47.1397,
    y2: 63.9611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0796,
    style: {
      stopColor: "#96918A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    style: {
      stopColor: "#B0B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_54_)",
    d: "M43.758,74.442c0.14-0.052,0.233-0.184,0.237-0.333c0.073-3.179,0.743-7.375,3.125-9.486 l0.136-0.429l0.042-0.124l0.016-0.041c-0.4,0.298-0.667,0.571-0.846,0.752l-0.086,0.088c-1.091,1.09-1.887,3.002-2.366,5.681 c-0.147,0.821-0.215,1.508-0.288,2.234c-0.025,0.249-0.047,0.576-0.056,0.815c-0.005,0.13-0.014,0.502-0.014,0.502 c0,0.01-0.007,0.019-0.016,0.022l-0.055,0.089L43.758,74.442z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.3483,
    y1: 74.4331,
    x2: 41.592,
    y2: 56.9777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B3B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#B0B1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#A29F98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#979289"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_55_)",
    d: "M43.189,57c-2.508,2.588-3.78,5.46-3.78,8.54c0,0.788,0.098,1.575,0.291,2.342 c0.171,0.678,0.42,1.355,0.74,2.013c0.493,1.013,1.153,1.982,2.017,2.965c0.23,0.261,0.499,0.564,0.782,0.85 c0.077,0.078,0.376,0.407,0.376,0.407c0.005,0.005,0.011,0.008,0.018,0.008c0.003,0,0.006,0,0.008-0.001v0.024l0.032,0.066 l0.085,0.227c-0.142,0.053-0.298,0.012-0.397-0.096c0,0-0.775-0.822-1.161-1.261c-4.446-5.058-3.911-10.942,0.026-15.535 l0.542-0.372L43.189,57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.4259,
    y1: 60.4899,
    x2: 43.1824,
    y2: 56.9876
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0796,
    style: {
      stopColor: "#96918A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    style: {
      stopColor: "#B0B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_56_)",
    d: "M36.731,60.576c0.002,0.001,0.004,0.001,0.006,0.001c0.007,0,0.013-0.003,0.018-0.008 c0,0,0.232-0.255,0.303-0.325c0.743-0.743,1.484-1.352,2.201-1.809c0.723-0.46,1.466-0.802,2.272-1.045 c0.448-0.135,0.892-0.244,1.359-0.335c0.097-0.019,0.197-0.037,0.299-0.055l-0.071,0.037l-0.207,0.112l-0.685,0.4 c-1.694,0.425-3.135,1.14-4.93,2.934c-0.219,0.219-0.364,0.498-0.656,0.421l0.012-0.263L36.731,60.576z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.1791,
    y1: 59.6074,
    x2: 44.1363,
    y2: 49.9346
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B3B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5636,
    style: {
      stopColor: "#B0B1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8374,
    style: {
      stopColor: "#A29F98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#979289"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_57_)",
    d: "M42.06,51.018c-1.822,0.789-2.684,1.279-3.759,2.353c-2.106,2.105-2.516,4.464-1.921,7.257 c0.029,0.134,0.129,0.24,0.261,0.276l0.063-0.235l0.019-0.07l0.008-0.023c-0.009-0.002-0.016-0.009-0.017-0.018 c0,0-0.074-0.348-0.09-0.446c-0.09-0.575-0.165-1.096-0.165-1.636c0-1.844,0.701-3.481,2.084-4.863 c1.306-1.306,2.307-1.725,5.281-2.97l0.741-0.311l-1.27,0.274L42.06,51.018z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.081,
    y1: 48.9753,
    x2: 44.5192,
    y2: 50.644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8F9096"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    style: {
      stopColor: "#B0B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_58_)",
    d: "M33.369,47.539c-0.104,0.099-0.14,0.249-0.093,0.384c0.922,2.63,3.122,3.278,5.954,3.278 c1.103,0,1.846-0.058,2.829-0.183l1.78-0.489l0.544-0.149l0.182-0.049c-0.37,0.051-1.127,0.157-1.127,0.157 c-1.827,0.256-2.66,0.373-4.206,0.373c-2.195,0-3.709-0.447-4.629-1.367c-0.212-0.213-0.375-0.423-0.515-0.665 c-0.097-0.168-0.231-0.414-0.315-0.599c-0.042-0.091-0.136-0.311-0.174-0.42c-0.003-0.009-0.001-0.019,0.006-0.026l-0.047-0.087 L33.369,47.539z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.8501,
    y1: 48.8679,
    x2: 45.7431,
    y2: 44.5627
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0504,
    style: {
      stopColor: "#8D867D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#9B9C9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6213,
    style: {
      stopColor: "#A2A3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8469,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_59_)",
    d: "M45.13,43.736c-0.356,0.799-1.964,2.059-2.674,2.57c-2.963,2.129-4.834,2.733-8.699,1.159 c-0.134-0.054-0.285-0.025-0.388,0.073l0.167,0.176l0.05,0.053l0.018,0.018c0.005-0.004,0.011-0.007,0.017-0.007 c0.003,0,0.006,0.001,0.009,0.002c0.101,0.041,1.02,0.376,1.13,0.411c0.227,0.074,0.486,0.151,0.708,0.209 c0.761,0.199,1.407,0.292,2.033,0.292c1.845,0,3.339-0.808,5.153-2.111c0.758-0.545,1.397-1.075,1.898-1.577 c0.688-0.688,0.887-1.095,0.914-1.201l-0.097-0.117L45.13,43.736z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.8483,
    y1: 42.7997,
    x2: 30.2245,
    y2: 36.896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B3B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    style: {
      stopColor: "#B0B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_60_)",
    d: "M29.575,38.614c0.108,0.095,0.262,0.117,0.393,0.057c1.655-0.765,5.433-2.615,7.489-0.301 c0.573,0.644,1.765,1.985,3.981,2.567c3.594,0.944,3.66,1.819,3.693,2.799l0.244,0.038l0.072,0.009l0.022,0.021 c0.002-0.008,0.003-0.015,0.003-0.019c-0.035-1.108-0.068-2.157-3.947-3.176c-2.117-0.556-3.263-1.845-3.813-2.465 c-0.111-0.125-0.207-0.233-0.263-0.279c-0.771-0.631-1.721-0.951-2.824-0.951c-0.813,0-1.698,0.179-2.708,0.547 c-0.556,0.203-1.006,0.4-1.642,0.694l-0.449,0.207c-0.003,0.002-0.007,0.002-0.01,0.002c-0.006,0-0.012-0.002-0.016-0.006 l-0.092,0.039L29.575,38.614z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.1917,
    y1: 38.1216,
    x2: 38.519,
    y2: 31.0418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEC1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    style: {
      stopColor: "#C2C5C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0191,
    style: {
      stopColor: "#D6DAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    style: {
      stopColor: "#E4E8E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#F4F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    style: {
      stopColor: "#EEF0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8411,
    style: {
      stopColor: "#DCDDDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#D0D1CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9442,
    style: {
      stopColor: "#BEC1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#B7BABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#B0B3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADB1B3"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_61_)",
    d: "M39.851,32.799c-0.032-0.053-0.078-0.098-0.134-0.129c-4.185-2.322-8.165-1.128-10.102,5.09 l-0.147,0.472c-0.043,0.137-0.001,0.287,0.108,0.382l0.16-0.182l0.048-0.055l0.018-0.018c-0.007-0.006-0.01-0.016-0.007-0.025 l0.147-0.472c0.171-0.547,0.356-1.05,0.6-1.631c0.207-0.492,0.42-0.921,0.651-1.31c0.772-1.298,1.724-2.184,2.831-2.632 c0.576-0.233,1.206-0.352,1.87-0.352c1.628,0,3.102,0.721,3.66,1.031l0.098-0.025L39.851,32.799z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.2703,
    y1: 34.8615,
    x2: 47.1083,
    y2: 36.0329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3181,
    style: {
      stopColor: "#AEB0AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#9B9C9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    style: {
      stopColor: "#9C9890"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9596,
    style: {
      stopColor: "#AAA9A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_62_)",
    d: "M47.196,33.854c-0.091,0.063-0.148,0.164-0.155,0.274c-0.009,0.136-0.124,0.394-0.265,0.711 c-1.756,3.94-6.803,3.027-6.872-1.856c-0.001-0.066-0.02-0.13-0.053-0.184l-0.216,0.113l-0.06,0.042l-0.021,0.013 c0.007,0.004,0.012,0.012,0.012,0.02c0.04,2.743,1.628,4.643,3.852,4.643c1.038,0,1.883-0.361,2.659-1.137 c0.409-0.409,0.74-0.905,1.012-1.515c0.167-0.374,0.281-0.631,0.294-0.827c0.001-0.007,0.004-0.014,0.01-0.018l-0.031-0.094 L47.196,33.854z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.2086,
    y1: 33.8318,
    x2: 48.4078,
    y2: 34.4856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001028834,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1703,
    style: {
      stopColor: "#908980"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4239,
    style: {
      stopColor: "#9D9995"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ACADAD"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_63_)",
    d: "M48.303,34.218c-0.105-0.083-0.212-0.153-0.321-0.21c-0.255-0.133-0.558-0.314-0.786-0.154 l0.139,0.199l0.042,0.06l0.015,0.02c0.004-0.003,0.009-0.004,0.014-0.004c0.002,0,0.005,0,0.007,0.001 c0.137,0.04,0.236,0.087,0.414,0.18c0.113,0.059,0.225,0.137,0.336,0.232c0.053,0.046,0.101,0.089,0.142,0.133l0.046-0.174 L48.303,34.218z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.1984,
    y1: 34.5604,
    x2: 49.1311,
    y2: 33.6967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#918F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1657,
    style: {
      stopColor: "#95918C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4742,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6651,
    style: {
      stopColor: "#9B9890"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9498,
    style: {
      stopColor: "#A7A7A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAAAA9"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_64_)",
    points: "48.751,33.819 48.303,34.218 48.306,34.541 48.304,34.64 48.305,34.675 49.253,33.829  49.04,33.755  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.7257,
    y1: 32.1206,
    x2: 49.3011,
    y2: 33.5403
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B3B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8278,
    style: {
      stopColor: "#AFB0AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAAAA9"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_65_)",
    d: "M40.688,32.346c0.024,0.094,0.085,0.174,0.169,0.223c2.068,1.208,3.786-0.62,6.621,0.501 c0.494,0.195,0.929,0.452,1.273,0.749l0.36,0.004l0.105,0.004l0.038,0.001c-0.028-0.028-0.063-0.063-0.09-0.09 c-0.397-0.398-0.937-0.738-1.559-0.984c-0.387-0.153-0.791-0.265-1.203-0.332c-0.233-0.038-0.477-0.062-0.724-0.072 c-0.094-0.004-0.184-0.005-0.271-0.005c-0.497,0-0.878,0.055-1.225,0.111c-0.12,0.019-0.234,0.041-0.348,0.062 c-0.367,0.069-0.746,0.14-1.3,0.14c-0.57,0-1.062-0.125-1.503-0.383c-0.011-0.006-0.014-0.02-0.008-0.031l-0.03,0.012 l-0.069,0.028L40.688,32.346z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.8448,
    y1: 31.9901,
    x2: 41.2515,
    y2: 30.1634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEC1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    style: {
      stopColor: "#C2C5C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0191,
    style: {
      stopColor: "#D6DAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2165,
    style: {
      stopColor: "#E5E9E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#F4F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8177,
    style: {
      stopColor: "#F2F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#EEF0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9437,
    style: {
      stopColor: "#E7E9E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#DDE0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDDFDC"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_66_",
    fill: "url(#_x30__x2C_475692mm_1_)",
    d: "M41.382,30.264c-0.007,0.107-0.05,0.21-0.126,0.292 c-0.245,0.264-0.7,0.754-1.003,1.282c-0.069,0.12-0.183,0.2-0.31,0.228l-0.175-0.243l0.072-0.181c0.014,0,0.028-0.007,0.035-0.02 c0.327-0.571,0.805-1.086,1.061-1.362c0.011-0.012,0.014-0.028,0.008-0.043l0.178-0.073L41.382,30.264z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.1995,
    y1: 30.3378,
    x2: 35.2997,
    y2: 15.7352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDF1F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0785,
    style: {
      stopColor: "#F4F7F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#F9FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F6F7F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F4F6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9824,
    style: {
      stopColor: "#F2F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0F3F3"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_65_",
    fill: "url(#_x30__x2C_475692mm_2_)",
    d: "M35.718,16.224c0.064,0.158,5.676,13.87,5.664,14.04 l-0.242-0.029l-0.153-0.013l-0.043-0.006l-5.875-14.43l0.361,0.172L35.718,16.224z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.6287,
    y1: 20.4242,
    x2: 36.0231,
    y2: 15.3104
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0377,
    style: {
      stopColor: "#CFD1CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#969CA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    style: {
      stopColor: "#858A8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0956,
    style: {
      stopColor: "#6E7176"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1186,
    style: {
      stopColor: "#5C5E63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1452,
    style: {
      stopColor: "#4F5056"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1786,
    style: {
      stopColor: "#47484E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#45464C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3013,
    style: {
      stopColor: "#57595C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3843,
    style: {
      stopColor: "#6A6E6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#717574"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    style: {
      stopColor: "#787C7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5982,
    style: {
      stopColor: "#8D8F8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#B1B1B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7946,
    style: {
      stopColor: "#C4C6C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#DDE0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8817,
    style: {
      stopColor: "#E2E5E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9165,
    style: {
      stopColor: "#EFF1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F4F7F6"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_64_",
    fill: "url(#_x30__x2C_475692mm_3_)",
    d: "M38.103,20.692c-0.196-0.141-0.254-0.407-0.137-0.617 c1.001-1.794-0.571-3.625-2.248-3.851l-0.369-0.264l-0.22-0.138l-0.058-0.034c0.107-0.014,0.217-0.021,0.328-0.021 c1.4,0,2.84,1.072,3.212,2.389c0.194,0.69,0.095,1.487-0.264,2.132c-0.01,0.018-0.005,0.04,0.012,0.052l-0.088,0.171 L38.103,20.692z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.1403,
    y1: 25.2331,
    x2: 43.1791,
    y2: 21.9285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BABDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#949DA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0915,
    style: {
      stopColor: "#7C8388"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1536,
    style: {
      stopColor: "#5E6267"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2054,
    style: {
      stopColor: "#4C4D53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#45464C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4982,
    style: {
      stopColor: "#5B5D60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7925,
    style: {
      stopColor: "#6E7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#757977"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_66_)",
    d: "M42.886,21.443c0.272,1.654-0.362,2.95-1.657,3.378c-0.342,0.1-0.534,0.145-0.761,0.145 c-0.141,0-0.299-0.017-0.546-0.058c-0.002,0-0.004-0.001-0.007-0.001c-0.013,0-0.026,0.007-0.033,0.018l-0.18-0.071l-0.179-0.175 c0.09-0.131,0.237-0.207,0.392-0.207c0.041,0,0.369,0.059,0.553,0.059c0.175,0,0.332-0.038,0.624-0.123 c1.087-0.359,1.597-1.432,1.368-2.872l0.165-0.152L42.886,21.443z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.6792,
    y1: 20.6702,
    x2: 38.3687,
    y2: 20.0951
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#757977"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#7C807E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1569,
    style: {
      stopColor: "#919391"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    style: {
      stopColor: "#C0C1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#DDE0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5145,
    style: {
      stopColor: "#E0E3E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5483,
    style: {
      stopColor: "#EAECEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#EFF1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6392,
    style: {
      stopColor: "#F2F5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#F4F7F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9699,
    style: {
      stopColor: "#F2F5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9825,
    style: {
      stopColor: "#EBEEED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9919,
    style: {
      stopColor: "#E0E2E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    style: {
      stopColor: "#D0D2CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CFD1CE"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_63_",
    fill: "url(#_x30__x2C_475692mm_4_)",
    d: "M42.46,21.536c-0.489-1.671-2.575-2.164-3.728-0.908 c-0.163,0.178-0.433,0.205-0.629,0.064l0.142-0.197l0.089-0.123l0.024-0.033c0.007,0.005,0.016,0.008,0.024,0.008 c0.011,0,0.022-0.004,0.03-0.013c0.323-0.352,0.737-0.609,1.197-0.743c0.239-0.07,0.485-0.105,0.732-0.105 c1.175,0,2.222,0.805,2.546,1.957L42.46,21.536z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.7812,
    y1: 26.7009,
    x2: 49.8108,
    y2: 25.2378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0103,
    style: {
      stopColor: "#BABDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0261,
    style: {
      stopColor: "#B3B6B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    style: {
      stopColor: "#9EA3A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#93999B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1015,
    style: {
      stopColor: "#8A8E90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#838789"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1512,
    style: {
      stopColor: "#84888A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2144,
    style: {
      stopColor: "#A8ABAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2803,
    style: {
      stopColor: "#C5C8C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3504,
    style: {
      stopColor: "#DCDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4257,
    style: {
      stopColor: "#ECEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5096,
    style: {
      stopColor: "#F6F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#F9FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9003,
    style: {
      stopColor: "#F2F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#EFF1F0"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_62_",
    fill: "url(#_x30__x2C_475692mm_5_)",
    d: "M49.328,23.3c0.167,0.152,0.205,0.401,0.089,0.596 c-1.228,2.06-2.796,4.166-5.116,4.166c-2.559,0-3.767-1.148-4.794-2.871c-0.095-0.159-0.089-0.359,0.016-0.512l0.2,0.137 l0.125,0.086l0.033,0.023c-0.009,0.013-0.009,0.03-0.001,0.044c0.978,1.641,2.058,2.658,4.42,2.658 c2.102,0,3.577-1.999,4.742-3.954c0.01-0.017,0.007-0.038-0.008-0.051l0.101-0.165L49.328,23.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.4803,
    y1: 20.7622,
    x2: 48.8595,
    y2: 18.9304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#F4F7F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5885,
    style: {
      stopColor: "#F2F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#EFF1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#DDE0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9469,
    style: {
      stopColor: "#E8EAE8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#EFF1EF"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_67_)",
    d: "M44.755,21.42c0-1.489,1.189-2.701,2.651-2.701c0.473,0,0.947,0.124,1.334,0.349 c0.006,0.004,0.013,0.006,0.02,0.006c0.012,0,0.024-0.006,0.032-0.016l0.171,0.089l0.175,0.174 c-0.145,0.191-0.41,0.243-0.617,0.123c-1.449-0.842-3.331,0.208-3.331,1.975l-0.211,0.171L44.755,21.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.9443,
    y1: 24.0318,
    x2: 44.5235,
    y2: 22.1188
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#EFF1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#D8DAD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1794,
    style: {
      stopColor: "#C4C5C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#BDBEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3597,
    style: {
      stopColor: "#C4C5C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5385,
    style: {
      stopColor: "#D8D9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7536,
    style: {
      stopColor: "#F8FAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#F9FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#F4F7F6"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_61_",
    fill: "url(#_x30__x2C_475692mm_6_)",
    d: "M45.191,21.42c0,1.895,2.117,2.889,3.536,1.848 c0.182-0.134,0.433-0.121,0.601,0.031l-0.163,0.18l-0.102,0.112l-0.027,0.03c-0.008-0.007-0.017-0.011-0.027-0.011 c-0.008,0-0.017,0.003-0.024,0.008c-0.44,0.323-1,0.501-1.578,0.501c-1.462,0-2.651-1.211-2.651-2.7H45.191z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.7726,
    y1: 19.0636,
    x2: 51.5736,
    y2: 14.4273
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    style: {
      stopColor: "#CFD1CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156,
    style: {
      stopColor: "#C8CAC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0314,
    style: {
      stopColor: "#B3B7B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#93999B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0903,
    style: {
      stopColor: "#7B8085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1529,
    style: {
      stopColor: "#5B5F69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2051,
    style: {
      stopColor: "#484A57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#414351"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2882,
    style: {
      stopColor: "#494B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4329,
    style: {
      stopColor: "#5D6061"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#646765"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5787,
    style: {
      stopColor: "#6B6E6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    style: {
      stopColor: "#808280"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7389,
    style: {
      stopColor: "#A1A1A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#C0C1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#DDE0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9327,
    style: {
      stopColor: "#E2E5E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EFF1F0"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_68_)",
    d: "M50.628,14.358c1.461,0,2.65,1.211,2.65,2.701c0,0.718-0.311,1.457-0.832,1.975 c-0.014,0.014-0.016,0.037-0.003,0.054l-0.131,0.142L52.1,19.356c-0.148-0.19-0.132-0.46,0.039-0.63 c1.479-1.471,0.456-3.932-1.511-3.932l-0.131-0.222L50.628,14.358z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.3971,
    y1: 19.074,
    x2: 49.5716,
    y2: 14.7512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#F0F2F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#DDE0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#EFF1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4115,
    style: {
      stopColor: "#F2F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#F9FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8982,
    style: {
      stopColor: "#F6F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#EFF1F0"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_60_",
    fill: "url(#_x30__x2C_475692mm_7_)",
    d: "M50.628,14.794c-1.989,0-2.969,2.492-1.534,3.9 c0.171,0.168,0.191,0.437,0.045,0.628l-0.193-0.147l-0.121-0.092l-0.032-0.025c0.012-0.016,0.011-0.039-0.004-0.053 c-0.524-0.514-0.812-1.205-0.812-1.945c0-1.489,1.189-2.701,2.651-2.701V14.794z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.3439,
    y1: 24.0879,
    x2: 56.3351,
    y2: 22.2182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#BABDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0316,
    style: {
      stopColor: "#C2C5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0666,
    style: {
      stopColor: "#D6DAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1359,
    style: {
      stopColor: "#D6DAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    style: {
      stopColor: "#C2C5C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2875,
    style: {
      stopColor: "#A1A4A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3807,
    style: {
      stopColor: "#73767F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#414351"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    style: {
      stopColor: "#55585D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#636765"
    }
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_69_)",
    d: "M56.499,21.42c0,1.489-1.189,2.7-2.651,2.7c-0.564,0-1.577-0.5-1.587-0.505 c-0.006-0.003-0.012-0.004-0.018-0.004c-0.011,0-0.022,0.004-0.03,0.013l-0.165-0.1l-0.154-0.196 c0.14-0.152,0.367-0.198,0.561-0.103c0.358,0.178,1.054,0.459,1.394,0.459c1.222,0,2.216-1.016,2.216-2.265l0.208-0.16 L56.499,21.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.5945,
    y1: 20.6993,
    x2: 52.5739,
    y2: 18.8244
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#636765"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1001,
    style: {
      stopColor: "#6A6E6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2348,
    style: {
      stopColor: "#7F8180"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3968,
    style: {
      stopColor: "#A0A09F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#C0C1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#DDE0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6345,
    style: {
      stopColor: "#E0E3E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6683,
    style: {
      stopColor: "#EAECEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#EFF1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9015,
    style: {
      stopColor: "#F2F4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#F4F7F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9808,
    style: {
      stopColor: "#F1F4F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    style: {
      stopColor: "#E8EBE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#D9DCD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CFD1CE"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_59_",
    fill: "url(#_x30__x2C_475692mm_8_)",
    d: "M56.064,21.42c0-1.756-1.878-2.838-3.342-1.951 c-0.206,0.125-0.473,0.076-0.621-0.114l0.191-0.15l0.12-0.094l0.032-0.025c0.008,0.01,0.02,0.016,0.032,0.016 c0.007,0,0.014-0.002,0.021-0.006c0.407-0.247,0.875-0.378,1.353-0.378c1.462,0,2.651,1.211,2.651,2.701H56.064z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.7476,
    y1: 25.235,
    x2: 61.6385,
    y2: 26.7308
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#BABDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0315,
    style: {
      stopColor: "#B3B6B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0486,
    style: {
      stopColor: "#9EA4A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#8D9497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1784,
    style: {
      stopColor: "#838889"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#7D8182"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3424,
    style: {
      stopColor: "#989C9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4188,
    style: {
      stopColor: "#B9BCBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#D2D5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5792,
    style: {
      stopColor: "#E5E7E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6644,
    style: {
      stopColor: "#EFF2F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#F3F5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#EEF0EF"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_58_",
    fill: "url(#_x30__x2C_475692mm_9_)",
    d: "M61.696,24.679c0.105,0.153,0.111,0.353,0.016,0.512 c-1.05,1.76-2.21,2.851-4.746,2.851c-2.356,0-3.98-2.216-5.131-4.147c-0.108-0.181-0.084-0.412,0.06-0.567l0.178,0.165 l0.112,0.103l0.03,0.027c-0.012,0.013-0.014,0.033-0.005,0.048c1.092,1.832,2.62,3.935,4.758,3.935 c2.341,0,3.376-0.968,4.372-2.639c0.008-0.013,0.008-0.03-0.001-0.044l0.136-0.137L61.696,24.679z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.462,
    y1: 20.6603,
    x2: 62.9275,
    y2: 20.3872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#F0F2F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F3F5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#EEF0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#D0D3D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9387,
    style: {
      stopColor: "#D6D9D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#DDE0DE"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_70_)",
    d: "M58.334,21.439c0.258-1.164,1.37-1.953,2.545-1.953c0.246,0,0.493,0.035,0.732,0.105 c0.459,0.134,0.873,0.391,1.199,0.743c0.008,0.008,0.019,0.013,0.03,0.013c0.008,0,0.017-0.003,0.024-0.008l0.137,0.136 l0.119,0.216c-0.084,0.061-0.182,0.091-0.279,0.091c-0.129,0-0.256-0.052-0.349-0.153c-1.218-1.315-3.377-0.667-3.731,0.906 l-0.288,0.155L58.334,21.439z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.0371,
    y1: 25.1967,
    x2: 58.132,
    y2: 22.0374
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#EEF0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0616,
    style: {
      stopColor: "#D3D6D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1363,
    style: {
      stopColor: "#B2B6BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1984,
    style: {
      stopColor: "#9DA3A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#969CA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349,
    style: {
      stopColor: "#9DA3A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    style: {
      stopColor: "#B2B7B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7077,
    style: {
      stopColor: "#D3D6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#DDE0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8972,
    style: {
      stopColor: "#E6E8E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0F2F1"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_57_",
    fill: "url(#_x30__x2C_475692mm_10_)",
    d: "M58.759,21.536c-0.435,1.935,0.862,3.211,2.466,2.942 c0.027-0.004,0.053-0.007,0.079-0.007c0.155,0,0.303,0.076,0.393,0.207l-0.201,0.137l-0.125,0.086l-0.033,0.023 c-0.008-0.011-0.02-0.018-0.033-0.018c-0.002,0-0.004,0-0.007,0.001c-0.246,0.042-0.404,0.058-0.545,0.058 c-0.227,0-0.419-0.045-0.763-0.145c-1.293-0.428-2.019-1.741-1.654-3.382L58.759,21.536z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.9172,
    y1: 20.5125,
    x2: 64.9848,
    y2: 15.4713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    style: {
      stopColor: "#DDE0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#999D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#EDF1F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#F3F5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8966,
    style: {
      stopColor: "#F0F2F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    style: {
      stopColor: "#E7E9E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9636,
    style: {
      stopColor: "#D7DAD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#C3C7C5"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_56_",
    fill: "url(#_x30__x2C_475692mm_11_)",
    d: "M65.502,16.223c-1.686,0.226-3.248,2.064-2.248,3.851 c0.118,0.21,0.06,0.475-0.135,0.617l-0.143-0.196l-0.09-0.123l-0.024-0.033c0.017-0.012,0.022-0.035,0.011-0.053 c-0.361-0.645-0.46-1.442-0.265-2.131c0.37-1.317,1.811-2.389,3.211-2.389c0.111,0,0.221,0.007,0.329,0.021l-0.058,0.034 l-0.213,0.213L65.502,16.223z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.2929,
    y1: 29.599,
    x2: 65.9849,
    y2: 15.7205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#848A8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#80838A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#6D706E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#686B6B"
    }
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_55_",
    fill: "url(#_x30__x2C_475692mm_12_)",
    d: "M60.348,29.622c-0.12-0.139-0.147-0.332-0.078-0.496 l5.232-12.902l0.363-0.264l0.284-0.172l-5.478,13.507c-0.01,0.015-0.007,0.032,0.004,0.046l-0.115,0.15L60.348,29.622z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.3291,
    y1: 29.5303,
    x2: 67.5707,
    y2: 28.0175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEC1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0098,
    style: {
      stopColor: "#C0C3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1117,
    style: {
      stopColor: "#D5D8D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#DCDFDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#DDE0DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    style: {
      stopColor: "#D6D9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#C3C7C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    style: {
      stopColor: "#BEC1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#B7BABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9771,
    style: {
      stopColor: "#B0B3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADB1B3"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_54_",
    fill: "url(#_x30__x2C_475692mm_13_)",
    d: "M67.097,28.631c-2.084-0.386-4.267,0.213-6.188,1.111 c-0.192,0.09-0.421,0.042-0.561-0.121l0.184-0.159l0.111-0.092l0.033-0.03c0.007,0.008,0.018,0.012,0.028,0.012 c0.007,0,0.014-0.002,0.021-0.005c1.805-0.844,3.5-1.271,5.039-1.271c0.647,0,1.257,0.074,1.866,0.225l-0.243,0.177L67.097,28.631 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.2854,
    y1: 35.3081,
    x2: 67.6156,
    y2: 28.2948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414351"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0603,
    style: {
      stopColor: "#40414A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1501,
    style: {
      stopColor: "#3C3B35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#393624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    style: {
      stopColor: "#3D3B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3394,
    style: {
      stopColor: "#494940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#585A58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5558,
    style: {
      stopColor: "#787D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6844,
    style: {
      stopColor: "#8F9599"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#989EA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FA5A9"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_53_",
    fill: "url(#_x30__x2C_475692mm_14_)",
    d: "M63.948,35.148c-0.027-0.144,0.014-0.292,0.111-0.402 c1.737-1.974,2.528-4.168,3.038-6.115l0.299-0.187l0.185-0.113l0.049-0.029c-0.52,2.102-1.315,4.54-3.244,6.732 c-0.008,0.009-0.012,0.022-0.009,0.034l-0.184,0.058L63.948,35.148z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.9395,
    y1: 47.7898,
    x2: 65.2029,
    y2: 34.5112
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#393624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0916,
    style: {
      stopColor: "#3C392B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2284,
    style: {
      stopColor: "#444340"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#51515E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4227,
    style: {
      stopColor: "#585864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4866,
    style: {
      stopColor: "#6C6D76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5633,
    style: {
      stopColor: "#8B8E93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#A7ABAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#ABB0B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B0B5B6"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_52_",
    fill: "url(#_x30__x2C_475692mm_15_)",
    d: "M70.712,46.466c-0.291-5.46-2.265-8.771-6.476-10.962 l-0.041-0.021c-0.13-0.067-0.221-0.191-0.248-0.334l0.239-0.045l0.15-0.028l0.04-0.007c0.002,0.012,0.01,0.023,0.021,0.028 l0.032,0.017c4.638,2.413,6.658,6.114,6.753,12.376l-0.006,0.206c-0.004,0.166-0.007,0.291-0.025,0.495l-0.242-0.907 L70.712,46.466z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.5985,
    y1: 47.6274,
    x2: 66.5057,
    y2: 43.5764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#918F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0046,
    style: {
      stopColor: "#949295"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0365,
    style: {
      stopColor: "#A5A5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0737,
    style: {
      stopColor: "#B1B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1208,
    style: {
      stopColor: "#B8BBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#BABDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4957,
    style: {
      stopColor: "#D9DCDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#DDE0DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#DCDFDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8374,
    style: {
      stopColor: "#D9DCD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8962,
    style: {
      stopColor: "#CFD3D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9488,
    style: {
      stopColor: "#BFC3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9977,
    style: {
      stopColor: "#A8ACAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7ABAC"
    }
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_51_",
    fill: "url(#_x30__x2C_475692mm_16_)",
    d: "M66.117,44.099c0.074-0.187,0.262-0.317,0.483-0.3 c1.522,0.128,3.03,0.969,4.113,2.666l0.277,0.967l0.133,0.605l0.029,0.152c-0.082-0.17-0.228-0.467-0.331-0.665 c-0.44-0.838-0.846-1.422-1.317-1.893c-0.687-0.687-1.588-1.163-2.537-1.342c-0.132-0.025-0.263-0.045-0.403-0.057 c-0.001,0-0.002,0-0.003,0c-0.017,0-0.031,0.01-0.038,0.026l-0.189-0.041L66.117,44.099z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.1271,
    y1: 62.6628,
    x2: 67.9215,
    y2: 43.887
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414351"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0792,
    style: {
      stopColor: "#41424F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1077,
    style: {
      stopColor: "#3F4048"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1281,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1444,
    style: {
      stopColor: "#3A382C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#393624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2312,
    style: {
      stopColor: "#48473C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3202,
    style: {
      stopColor: "#545551"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#585A58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5379,
    style: {
      stopColor: "#737777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#9FA5A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A4A8A9"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_50_",
    fill: "url(#_x30__x2C_475692mm_17_)",
    d: "M68.452,61.837c0.143-0.217,0.287-0.451,0.432-0.702 c2.956-5.125,1.92-12.923-2.619-16.488c-0.165-0.13-0.226-0.353-0.149-0.548l0.226,0.089l0.142,0.056l0.038,0.015 c-0.007,0.017-0.001,0.036,0.012,0.047c0.098,0.077,0.192,0.158,0.28,0.238c1.432,1.258,2.526,2.858,3.251,4.755 c0.616,1.611,0.915,3.317,0.915,5.214c0,2.56-0.579,4.862-1.72,6.84c-0.354,0.614-0.693,1.116-1.035,1.533l0.094-0.543 L68.452,61.837z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.6475,
    y1: 62.632,
    x2: 65.0286,
    y2: 56.6329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#918F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0046,
    style: {
      stopColor: "#949295"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0365,
    style: {
      stopColor: "#A5A5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0737,
    style: {
      stopColor: "#B1B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1208,
    style: {
      stopColor: "#B8BBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#BABDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4957,
    style: {
      stopColor: "#D9DCD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#DDE0DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#DCDFDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8398,
    style: {
      stopColor: "#D9DCD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9005,
    style: {
      stopColor: "#CFD3D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    style: {
      stopColor: "#BFC3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ABB0B2"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_49_",
    fill: "url(#_x30__x2C_475692mm_18_)",
    d: "M64.421,57.02c0.137-0.145,0.349-0.191,0.534-0.112 c1.955,0.834,2.983,2.876,3.498,4.929l-0.114,0.59l-0.087,0.363l-0.025,0.095c-0.131-0.783-0.317-1.475-0.6-2.231 c-0.525-1.399-1.252-2.384-2.222-3.012c-0.215-0.138-0.417-0.248-0.62-0.335c-0.005-0.002-0.01-0.003-0.016-0.003 c-0.011,0-0.022,0.004-0.03,0.013l-0.159-0.109L64.421,57.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.5603,
    y1: 74.7474,
    x2: 66.5118,
    y2: 57.7528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414351"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1109,
    style: {
      stopColor: "#41424F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1508,
    style: {
      stopColor: "#3F4048"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1793,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2021,
    style: {
      stopColor: "#3A382C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#393624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    style: {
      stopColor: "#48473C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    style: {
      stopColor: "#545551"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#585A58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4521,
    style: {
      stopColor: "#6E7271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5031,
    style: {
      stopColor: "#828788"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    style: {
      stopColor: "#909698"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6193,
    style: {
      stopColor: "#989FA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#9BA2A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9831,
    style: {
      stopColor: "#A2A8AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3A8AB"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_48_",
    fill: "url(#_x30__x2C_475692mm_19_)",
    d: "M59.109,73.304c6.026-3.041,8.699-9.321,5.401-15.428 c-0.176-0.327-0.348-0.578-0.089-0.855l0.177,0.166l0.111,0.104l0.029,0.028c-0.011,0.012-0.014,0.031-0.007,0.046 c0.051,0.101,0.106,0.203,0.161,0.305c0.055,0.102,0.11,0.204,0.161,0.305c0.963,1.908,1.347,3.47,1.328,5.391 c-0.028,2.778-1.234,5.499-3.396,7.661c-0.713,0.713-1.514,1.354-2.381,1.907c-0.631,0.401-1.362,0.848-2.087,1.099l0.285-0.403 L59.109,73.304z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.3538,
    y1: 73.8295,
    x2: 57.3293,
    y2: 65.4613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#918F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0046,
    style: {
      stopColor: "#949295"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0365,
    style: {
      stopColor: "#A5A5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0737,
    style: {
      stopColor: "#B1B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1208,
    style: {
      stopColor: "#B8BBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#BABDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4884,
    style: {
      stopColor: "#D8DCDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#DCDFDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8398,
    style: {
      stopColor: "#D9DCD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9005,
    style: {
      stopColor: "#CFD3D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9547,
    style: {
      stopColor: "#BFC3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ABB0B2"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_47_",
    fill: "url(#_x30__x2C_475692mm_20_)",
    d: "M56.565,65.665c0.171-0.096,0.381-0.077,0.532,0.044 c2.189,1.768,2.477,4.804,2.012,7.595l-0.325,0.419l-0.21,0.246l-0.056,0.063c0.227-0.943,0.338-1.944,0.338-3.056 c0-1.787-0.485-3.249-1.442-4.344c-0.202-0.232-0.364-0.402-0.589-0.584c-0.008-0.006-0.017-0.009-0.025-0.009 c-0.007,0-0.014,0.002-0.02,0.005l-0.137-0.137L56.565,65.665z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.7139,
    y1: 81.4773,
    x2: 58.5419,
    y2: 67.1601
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414351"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0603,
    style: {
      stopColor: "#40414A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1501,
    style: {
      stopColor: "#3C3B35"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#393624"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    style: {
      stopColor: "#3D3B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3394,
    style: {
      stopColor: "#494940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#585A58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5558,
    style: {
      stopColor: "#787D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6844,
    style: {
      stopColor: "#8F9599"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#989EA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FA5A9"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_46_",
    fill: "url(#_x30__x2C_475692mm_21_)",
    d: "M46.512,79.561c6.905-0.203,11.16-5.028,9.864-13.095 c-0.055-0.346-0.129-0.622,0.189-0.801l0.119,0.212l0.075,0.132l0.02,0.035c-0.014,0.008-0.022,0.024-0.02,0.041 c0.011,0.085,0.029,0.195,0.048,0.312c0.019,0.119,0.039,0.244,0.055,0.358c0.132,0.938,0.195,1.759,0.194,2.511 c-0.003,1.42-0.195,2.732-0.571,3.9c-0.346,1.073-0.854,2.049-1.513,2.903c-1.422,1.841-3.26,3.002-5.618,3.549 c-1.116,0.259-2.167,0.384-3.213,0.384c-0.127,0-0.255-0.002-0.384-0.006l0.385-0.269L46.512,79.561z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.5284,
    y1: 80.0497,
    x2: 47.483,
    y2: 66.3992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#918F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0039,
    style: {
      stopColor: "#949295"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0313,
    style: {
      stopColor: "#A5A5A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0631,
    style: {
      stopColor: "#B1B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1035,
    style: {
      stopColor: "#B8BBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#BABDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2771,
    style: {
      stopColor: "#C1C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4218,
    style: {
      stopColor: "#D5D9D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    style: {
      stopColor: "#D7DAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#D0D3D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8492,
    style: {
      stopColor: "#CDD0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    style: {
      stopColor: "#C3C7C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9776,
    style: {
      stopColor: "#B3B8B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ABB0B2"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_45_",
    fill: "url(#_x30__x2C_475692mm_22_)",
    d: "M46.662,66.342c0.192,0.025,0.35,0.164,0.399,0.352 c0.887,3.419,1.442,9.191-0.549,12.867l-0.421,0.248l-0.266,0.148l-0.07,0.039l0.09-0.151c0.275-0.458,0.587-0.976,0.941-2.08 c0.433-1.353,0.653-2.937,0.653-4.708c0-1.102-0.121-2.496-0.341-3.925c-0.135-0.881-0.302-1.729-0.458-2.329 c-0.004-0.016-0.018-0.028-0.034-0.03l-0.035-0.191L46.662,66.342z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.3121,
    y1: 76.7656,
    x2: 46.2395,
    y2: 66.2643
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414351"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0957,
    style: {
      stopColor: "#484A53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#585A58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2641,
    style: {
      stopColor: "#5E615F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3448,
    style: {
      stopColor: "#707374"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#838789"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4535,
    style: {
      stopColor: "#8A8E90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    style: {
      stopColor: "#9CA2A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#A3A9AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    style: {
      stopColor: "#BDBEBD"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_44_",
    fill: "url(#_x30__x2C_475692mm_23_)",
    d: "M44.434,75.942c0.024-2.938,0.312-6.801,1.752-9.362 c0.096-0.17,0.286-0.264,0.476-0.238l-0.061,0.239v0.152l0.005,0.041c-0.002,0-0.003,0-0.005,0c-0.014,0-0.028,0.008-0.035,0.02 c-1.248,2.221-1.692,5.945-1.692,8.459c0,0.202-0.002,0.386-0.003,0.568c-0.003,0.325-0.006,0.644,0.001,1.047l-0.277-0.473 L44.434,75.942z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.1315,
    y1: 77.3869,
    x2: 37.9948,
    y2: 60.1564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#515858"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.024,
    style: {
      stopColor: "#585F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0599,
    style: {
      stopColor: "#6B7274"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    style: {
      stopColor: "#8B9295"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#91989B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.187,
    style: {
      stopColor: "#A2A8A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3025,
    style: {
      stopColor: "#B7BAB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#BEC1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    style: {
      stopColor: "#C5C8C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6169,
    style: {
      stopColor: "#D9DCDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#F4F7F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    style: {
      stopColor: "#EDEFEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0D2CF"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_43_",
    fill: "url(#_x30__x2C_475692mm_24_)",
    d: "M39.73,59.639c0.167,0.142,0.217,0.379,0.119,0.575 c-0.868,1.746-1.308,3.532-1.308,5.307c0,4.49,2.605,7.614,5.892,10.421l0.241,0.52l0.155,0.322l0.042,0.085 c-0.523-0.412-1.225-1.034-1.232-1.04c-3.672-3.085-5.533-6.553-5.533-10.307c0-1.843,0.455-3.694,1.353-5.501 c0.008-0.017,0.004-0.037-0.01-0.049l0.098-0.166L39.73,59.639z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.0237,
    y1: 62.8897,
    x2: 39.5535,
    y2: 59.4572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#585A58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1418,
    style: {
      stopColor: "#5E615F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#636765"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2769,
    style: {
      stopColor: "#6A6E6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3768,
    style: {
      stopColor: "#7C8081"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#838789"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5637,
    style: {
      stopColor: "#8C9498"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#919A9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8321,
    style: {
      stopColor: "#B0B6B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDDFDC"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_42_",
    fill: "url(#_x30__x2C_475692mm_25_)",
    d: "M36.382,62.259c0.8-0.96,1.639-1.824,2.761-2.641 c0.177-0.129,0.419-0.121,0.587,0.021c-0.179,0.212-0.145,0.171-0.255,0.302l-0.026,0.031c-0.008-0.006-0.017-0.009-0.026-0.009 c-0.008,0-0.017,0.002-0.024,0.008c-1.224,0.892-2.144,1.928-2.315,2.127l-0.845,1.015l0.037-0.44L36.382,62.259z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.2912,
    y1: 62.9185,
    x2: 37.5635,
    y2: 51.7497
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#918F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    style: {
      stopColor: "#989699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0289,
    style: {
      stopColor: "#A9A9AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0549,
    style: {
      stopColor: "#B5B7B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0878,
    style: {
      stopColor: "#BCBFBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#BEC1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2031,
    style: {
      stopColor: "#CDD0CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3144,
    style: {
      stopColor: "#E7E9E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#F1F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#F4F7F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8637,
    style: {
      stopColor: "#F2F5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9078,
    style: {
      stopColor: "#EBEEED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9405,
    style: {
      stopColor: "#DEE2E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    style: {
      stopColor: "#CDD1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#B6BBBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ABB0B2"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_41_",
    fill: "url(#_x30__x2C_475692mm_26_)",
    d: "M38.66,51.973c0.067,0.184,0.027,0.371-0.167,0.549 c-0.424,0.391-0.824,0.76-1.203,1.226c-1.132,1.395-1.706,2.979-1.706,4.709c0,1.368,0.321,2.474,0.798,3.801l-0.082,0.478 l-0.049,0.296l-0.013,0.079c-0.235-0.594-0.424-1.132-0.627-1.787c-0.32-1.032-0.463-1.916-0.463-2.867 c0-1.832,0.607-3.509,1.804-4.984c0.416-0.513,0.81-0.867,1.287-1.311c0.012-0.011,0.016-0.028,0.011-0.043l0.167-0.096 L38.66,51.973z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.0274,
    y1: 52.6874,
    x2: 31.5358,
    y2: 46.9442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#939A9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0502,
    style: {
      stopColor: "#A4A9AB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#ABB0B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1315,
    style: {
      stopColor: "#B6B8B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#BDBEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2483,
    style: {
      stopColor: "#C4C5C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#D6DAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#F9FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    style: {
      stopColor: "#F2F5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#EDF1F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    style: {
      stopColor: "#E6EAEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9571,
    style: {
      stopColor: "#D2D6D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9909,
    style: {
      stopColor: "#B1B5B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7ABAC"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_40_",
    fill: "url(#_x30__x2C_475692mm_27_)",
    d: "M32.745,46.674c-0.009,1.236,0.149,2.321,1.226,3.427 c1.119,1.146,2.668,1.473,4.266,1.558c0.191,0.01,0.357,0.134,0.422,0.314c-0.218,0.078-0.409,0.147-0.409,0.147 c-0.006-0.015-0.02-0.026-0.036-0.027c-1.082-0.058-1.958-0.217-2.678-0.49c-0.742-0.281-1.374-0.684-1.877-1.199 c-1.197-1.229-1.35-2.522-1.35-3.512c0-0.173,0.001-0.326,0.004-0.481c0.003-0.133,0.006-0.251,0.015-0.364l0.036,0.058 l0.236,0.208L32.745,46.674z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.3675,
    y1: 47.0083,
    x2: 42.1741,
    y2: 46.6144
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0334,
    style: {
      stopColor: "#ECEFEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0724,
    style: {
      stopColor: "#F6F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1238,
    style: {
      stopColor: "#F9FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2616,
    style: {
      stopColor: "#F2F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5356,
    style: {
      stopColor: "#E9EDEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6231,
    style: {
      stopColor: "#F1F5F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#F4F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8354,
    style: {
      stopColor: "#EDF0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#DDE0DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9623,
    style: {
      stopColor: "#D6D9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9955,
    style: {
      stopColor: "#C1C4C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEC1BF"
    }
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_39_",
    fill: "url(#_x30__x2C_475692mm_28_)",
    d: "M42.135,45.633c0.005,0.16-0.072,0.312-0.204,0.404 c-2.915,2.031-4.31,2.455-9.186,0.638l-0.237-0.35l-0.18-0.277c2.072,0.823,4.099,1.354,5.176,1.354 c1.044,0,2.043-0.338,3.238-1.097c0.306-0.193,0.605-0.392,0.94-0.625c0.011-0.008,0.018-0.021,0.017-0.034l0.187-0.048 L42.135,45.633z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.0891,
    y1: 39.9856,
    x2: 41.2509,
    y2: 48.1422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A7ABAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    style: {
      stopColor: "#B1B5B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0239,
    style: {
      stopColor: "#D2D6D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    style: {
      stopColor: "#E6EAEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#EDF1F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1044,
    style: {
      stopColor: "#F2F5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F9FBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    style: {
      stopColor: "#DBDDDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#BDBEBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4906,
    style: {
      stopColor: "#B2B6B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#ABB0B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6894,
    style: {
      stopColor: "#B2B7B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7928,
    style: {
      stopColor: "#C7CBCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9085,
    style: {
      stopColor: "#D1D5D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9602,
    style: {
      stopColor: "#B0B6B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#939A9C"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_38_",
    fill: "url(#_x30__x2C_475692mm_29_)",
    d: "M20.022,39.255c0.016,0.035,0.032,0.069,0.048,0.104 c0.466,1,1.506,3.396,2.994,4.696c6.332,5.349,11.873-3.106,18.844,1.187c0.137,0.084,0.222,0.231,0.226,0.392l-0.243,0.007 l-0.152,0.004l-0.04,0.001c-0.001-0.014-0.008-0.026-0.019-0.033c-0.89-0.548-1.998-1.231-4.041-1.231 c-1.572,0-3.124,0.461-4.768,0.948c-1.631,0.484-3.318,0.985-5.014,0.985c-1.878,0-3.538-0.63-5.073-1.927 c-1.401-1.224-2.487-3.494-2.69-3.936c-0.134-0.301-0.274-0.6-0.418-0.908c-0.259-0.557-0.527-1.131-0.801-1.79l0.69,0.826 L20.022,39.255z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.9135,
    y1: 37.6298,
    x2: 42.5967,
    y2: 44.961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0D3D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0292,
    style: {
      stopColor: "#D6D9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#DDE0DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2115,
    style: {
      stopColor: "#E4E7E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#F4F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3981,
    style: {
      stopColor: "#EFF2F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4554,
    style: {
      stopColor: "#E5E8E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    style: {
      stopColor: "#DFE2DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#DDE0DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    style: {
      stopColor: "#D6D9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#C1C5C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#A7ABAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9458,
    style: {
      stopColor: "#A1A4A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    style: {
      stopColor: "#918F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#918F92"
    }
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_37_",
    fill: "url(#_x30__x2C_475692mm_30_)",
    d: "M42.439,45.467c-0.126-0.024-0.237-0.099-0.307-0.207 c-0.538-0.822-0.861-1.24-1.386-1.787c-1.147-1.196-3.137-2.062-5.049-2.056c-0.66,0.006-1.271,0.138-1.979,0.29 c-4.857,1.048-9.737,0.58-13.695-2.453l-0.65-0.836l-0.396-0.53l-0.101-0.136c0.136,0.112,0.274,0.228,0.415,0.346 c0.694,0.582,1.481,1.242,2.481,1.788c2.174,1.274,4.646,1.894,7.558,1.894c1.987,0,3.267-0.276,4.296-0.498 c0.731-0.158,1.362-0.294,2.067-0.3l0.054,0c1.922,0,4.057,0.88,5.314,2.19c0.54,0.563,0.889,1.012,1.436,1.85 c0.006,0.009,0.016,0.016,0.026,0.018l-0.009,0.193L42.439,45.467z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.4723,
    y1: 45.499,
    x2: 44.378,
    y2: 43.5462
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEC1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    style: {
      stopColor: "#C2C5C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0191,
    style: {
      stopColor: "#D6DAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3588,
    style: {
      stopColor: "#EDF0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#F4F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7404,
    style: {
      stopColor: "#EDF0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9198,
    style: {
      stopColor: "#DADDDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0D3D0"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_36_",
    fill: "url(#_x30__x2C_475692mm_31_)",
    d: "M44.537,43.42c0.013,0.107-0.011,0.215-0.067,0.307 c-0.022,0.036-0.551,0.885-1.668,1.663c-0.08,0.056-0.175,0.085-0.272,0.085c-0.03,0-0.06-0.003-0.091-0.009l0.046-0.238 l0.029-0.149l0.008-0.04c0.003,0,0.005,0.001,0.008,0.001c0.008,0,0.016-0.003,0.023-0.007c1.044-0.727,1.542-1.526,1.546-1.534 l0.193-0.079H44.537z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.0743,
    y1: 39.1045,
    x2: 44.7017,
    y2: 41.3231
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#918F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004141688,
    style: {
      stopColor: "#918F92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0301,
    style: {
      stopColor: "#A1A4A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#A7ABAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1091,
    style: {
      stopColor: "#C1C5C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1695,
    style: {
      stopColor: "#D6D9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#DDE0DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4483,
    style: {
      stopColor: "#EDF0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#F4F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    style: {
      stopColor: "#F1F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8381,
    style: {
      stopColor: "#E9ECEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#DDE0DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9708,
    style: {
      stopColor: "#D6D9D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0D3D0"
    }
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_35_",
    fill: "url(#_x30__x2C_475692mm_32_)",
    d: "M28.407,40.335c2.502-1.811,6.725-3.817,8.637-1.627 c0.454,0.52,1.834,2.101,4.26,2.737c2.614,0.686,3.139,1.204,3.233,1.975l-0.241,0.029l-0.153,0.049H44.1 c-0.042-0.414-0.1-0.896-2.906-1.633c-2.555-0.671-4.002-2.328-4.477-2.872c-0.072-0.082-0.12-0.137-0.146-0.158 c-0.48-0.398-1.206-0.626-1.992-0.626c-1.293,0-2.732,0.601-3.712,1.106c-0.566,0.292-0.972,0.527-1.403,0.812 c-0.482,0.32-0.989,0.69-1.689,1.214l0.299-0.578L28.407,40.335z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x30__x2C_475692mm_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.2925,
    y1: 39.3876,
    x2: 38.6183,
    y2: 30.0319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BEC1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    style: {
      stopColor: "#C2C5C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0191,
    style: {
      stopColor: "#D6DAD8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DDE1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    style: {
      stopColor: "#E4E8E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#F4F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    style: {
      stopColor: "#EEF0F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8411,
    style: {
      stopColor: "#DCDDDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#D0D1CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9442,
    style: {
      stopColor: "#BEC1C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#B7BABA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#B0B3B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADB1B3"
    }
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "_x30__x2C_475692mm_34_",
    fill: "url(#_x30__x2C_475692mm_33_)",
    d: "M28.407,40.335c0.699-3.442,2.034-7.538,5.302-8.852 c1.927-0.776,4.078-0.384,5.917,0.544c0.099,0.05,0.21,0.063,0.317,0.04l-0.074-0.233l-0.019-0.151l-0.01-0.04 c-0.006,0-0.012-0.001-0.018-0.004c-0.909-0.459-2.327-1.005-3.923-1.005c-0.827,0-1.618,0.15-2.353,0.446 c-0.796,0.32-1.523,0.805-2.16,1.443c-1.457,1.457-2.565,3.878-3.295,7.196c-0.152,0.695-0.259,1.285-0.316,1.624l0.057-0.093 l0.217-0.352L28.407,40.335z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.2016,
    y1: 50.6295,
    x2: 49.5624,
    y2: 49.8721
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4B6B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_71_)",
    points: "48.519,50.643 49.316,50.214 49.461,49.915 49.487,49.736 48.115,50.473 48.249,50.579  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.4045,
    y1: 54.1089,
    x2: 49.199,
    y2: 49.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    style: {
      stopColor: "#96918A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5187,
    style: {
      stopColor: "#AFB0AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_72_)",
    d: "M48.911,54.132c-0.225-0.209-0.093-0.414,0.054-0.668c0.608-1.052,0.749-2.074,0.35-3.25 l0.127-0.344l0.034-0.101l0.01-0.033c0.062,0.132,0.12,0.272,0.173,0.435c0.103,0.318,0.22,0.754,0.22,1.308 c0,0.343-0.049,0.875-0.285,1.464c-0.142,0.355-0.24,0.526-0.336,0.691c-0.041,0.07-0.08,0.139-0.122,0.22 c-0.005,0.01-0.003,0.021,0.005,0.029l-0.051,0.083L48.911,54.132z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.7267,
    y1: 54.4703,
    x2: 52.2744,
    y2: 47.7634
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1616,
    style: {
      stopColor: "#9F9C95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4B6B3"
    }
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_73_)",
    d: "M52.374,48.457c-0.007,0.118-0.014,0.236-0.022,0.355c-0.144,2.098-0.609,3.461-2.181,4.757 c-0.173,0.143-0.789,0.66-1.011,0.66c-0.09,0-0.179-0.033-0.248-0.097l0.165-0.178l0.05-0.053l0.017-0.018 c0.005,0.004,0.011,0.006,0.017,0.006c0.004,0,0.009-0.001,0.013-0.003c0.324-0.199,0.567-0.401,0.782-0.578 c0.251-0.207,0.459-0.415,0.597-0.553c1.125-1.126,1.37-2.636,1.461-3.965c0.026-0.371,0.042-0.739,0.057-1.103l0.149,0.272 L52.374,48.457z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.0662,
    y1: 55.3263,
    x2: 52.1022,
    y2: 47.6771
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    style: {
      stopColor: "#96918A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#B0B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_74_)",
    d: "M52.985,55.604c-0.121-0.118-0.144-0.304-0.057-0.448c0.426-0.708,0.601-1.256,0.74-1.746 c0.686-2.423-0.359-3.972-1.295-4.953L52.158,47.9l-0.066-0.161l-0.022-0.053c0.128,0.116,0.257,0.24,0.391,0.374 c1.029,1.029,2.309,2.714,1.536,5.443c-0.08,0.279-0.189,0.662-0.365,1.029l-0.034,0.071c-0.129,0.27-0.241,0.503-0.377,0.729 c-0.006,0.01-0.004,0.022,0.004,0.03l-0.051,0.083L52.985,55.604z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.3736,
    y1: 55.9416,
    x2: 56.4771,
    y2: 45.4143
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1616,
    style: {
      stopColor: "#9F9C95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_75_)",
    d: "M56.438,45.856c0.63,2.576,0.915,5.126-0.503,7.39c-0.474,0.757-1.39,1.704-2.5,2.406 c-0.146,0.091-0.331,0.068-0.449-0.048l0.17-0.173l0.051-0.052l0.017-0.018c0.004,0.005,0.011,0.007,0.017,0.007 c0.004,0,0.009-0.001,0.013-0.003c0.293-0.185,0.451-0.297,0.803-0.571c0.269-0.209,0.503-0.443,0.774-0.715l0.034-0.034 c0.298-0.297,0.561-0.627,0.782-0.979c0.653-1.043,0.971-2.234,0.971-3.642c0-0.886-0.124-1.835-0.39-2.984 c-0.101-0.431-0.191-0.796-0.28-1.13l0.193,0.17L56.438,45.856z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.0228,
    y1: 51.1938,
    x2: 55.8242,
    y2: 45.4202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    style: {
      stopColor: "#96918A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#B0B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_76_)",
    d: "M60.286,51.858c-0.171-0.027-0.3-0.17-0.308-0.343c-0.12-2.616-1.063-4.597-3.54-5.659 l-0.35-0.397l-0.105-0.113l-0.035-0.037c0.402,0.132,0.764,0.285,1.135,0.477c0.55,0.285,1.039,0.639,1.454,1.054 c0.669,0.669,1.162,1.511,1.467,2.505c0.084,0.274,0.138,0.605,0.191,0.926l0.029,0.171c0.062,0.367,0.094,1.052,0.094,1.059 c0,0.012,0.009,0.021,0.02,0.023l0.012,0.097L60.286,51.858z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.4275,
    y1: 51.6543,
    x2: 59.3923,
    y2: 41.3754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    style: {
      stopColor: "#ABABA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9159,
    style: {
      stopColor: "#B4B5B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_77_)",
    d: "M59.325,41.439c1.878,2.278,2.233,3.978,2.233,6.122c0,1.441-0.366,2.689-0.875,4.063 c-0.062,0.167-0.233,0.26-0.398,0.233l0.038-0.24l0.011-0.072l0.004-0.024c0.001,0,0.002,0,0.004,0 c0.01,0,0.019-0.006,0.023-0.015c0.002-0.006,0.228-0.615,0.331-0.945c0.097-0.314,0.233-0.78,0.33-1.222 c0.128-0.587,0.193-1.185,0.193-1.778c0-0.742-0.029-1.544-0.239-2.377c-0.216-0.857-0.6-1.673-1.207-2.567 c-0.218-0.321-0.48-0.697-0.828-1.103l0.126-0.075H59.325z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.1159,
    y1: 41.5664,
    x2: 59.6265,
    y2: 39.8751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4B6B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4B6B3"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_78_)",
    points: "59.632,40.478 59.325,41.439 59.053,41.492 58.971,41.509 58.944,41.514 59.482,39.831  59.563,40.052  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.866,
    y1: 55.6987,
    x2: 60.8383,
    y2: 39.8291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1559,
    style: {
      stopColor: "#96918A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    style: {
      stopColor: "#B0B1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_79_)",
    d: "M59.342,54.752c1.929-2.176,3.097-4.554,3.097-7.48c0-2.377-0.751-4.56-2.808-6.794l-0.106-0.464 l-0.033-0.137l-0.011-0.046l0.053,0.053c0.536,0.541,0.997,1.092,1.45,1.737c0.72,1.024,1.209,2.056,1.493,3.156 c0.203,0.787,0.302,1.603,0.302,2.495c0,2.034-0.567,3.962-1.686,5.73c-0.617,0.975-1.218,1.674-1.776,2.284l-0.38,0.416 l0.123-0.355L59.342,54.752z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.5814,
    y1: 55.5557,
    x2: 57.9947,
    y2: 48.5715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B3B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#B0B1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#A29F98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#979289"
    }
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_80_)",
    d: "M58.026,48.565c0.161-0.047,0.334,0.022,0.419,0.169c0.972,1.703,0.994,3.953,0.898,6.018 l-0.287,0.678l-0.088,0.204l-0.029,0.068l0.041-0.562c0.047-0.647,0.047-1.217,0.047-1.821v-0.125 c0-0.627-0.023-1.138-0.072-1.609c-0.08-0.754-0.23-1.396-0.459-1.964c-0.105-0.262-0.222-0.504-0.345-0.719 c-0.004-0.008-0.012-0.012-0.021-0.012c-0.002,0-0.004,0-0.007,0.001l-0.071-0.069L58.026,48.565z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.1862,
    y1: 58.6002,
    x2: 58.7721,
    y2: 49.1652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0504,
    style: {
      stopColor: "#8D867D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#9B9C9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6213,
    style: {
      stopColor: "#A2A3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8469,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_81_)",
    d: "M50.766,57.146c2.562-0.424,4.478-1.22,5.873-3.425c0.896-1.418,1.214-3.076,1.126-4.787 c-0.009-0.168,0.099-0.321,0.261-0.368l0.068,0.233l0.02,0.07l0.007,0.023c-0.011,0.003-0.018,0.013-0.017,0.025 c0.008,0.146,0.013,0.29,0.013,0.426c0,0.918-0.093,1.725-0.285,2.466c-0.195,0.754-0.491,1.439-0.906,2.094 c-1.378,2.179-3.216,2.885-4.478,3.226c-0.656,0.177-1.328,0.315-1.998,0.41l-0.496,0.071l0.278-0.187L50.766,57.146z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.487,
    y1: 57.8225,
    x2: 52.6879,
    y2: 52.3198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B3B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    style: {
      stopColor: "#B0B1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    style: {
      stopColor: "#A29F98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#979289"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_82_)",
    d: "M50.766,57.146c0.998-1.283,2.019-2.859,2.164-4.449c0.016-0.17-0.089-0.328-0.252-0.38 l-0.108,0.226l0.005,0.098c0.011,0.003,0.018,0.014,0.017,0.025c-0.042,0.459-0.158,0.924-0.356,1.422 c-0.225,0.568-0.551,1.163-0.996,1.82c-0.269,0.397-0.573,0.831-0.968,1.314l-0.317,0.388l0.058-0.033l0.175-0.099L50.766,57.146z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.8018,
    y1: 56.4086,
    x2: 52.7834,
    y2: 52.5068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0504,
    style: {
      stopColor: "#8D867D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#9B9C9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6213,
    style: {
      stopColor: "#A2A3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8469,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_83_)",
    d: "M46.304,55.345c2.504-0.069,4.672-0.655,5.948-2.864c0.087-0.15,0.265-0.216,0.425-0.165 l-0.073,0.231l-0.022,0.07l-0.008,0.023c-0.002-0.001-0.005-0.001-0.007-0.001c-0.009,0-0.017,0.004-0.021,0.012 c-0.258,0.446-0.564,0.847-0.908,1.192c-0.859,0.86-1.962,1.401-3.373,1.655c-0.883,0.158-1.716,0.187-2.343,0.194l-0.516,0.006 l0.33-0.167L46.304,55.345z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.1503,
    y1: 56.0203,
    x2: 48.4839,
    y2: 50.6276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B3B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8278,
    style: {
      stopColor: "#AFB0AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAAAA9"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_84_)",
    d: "M48.519,50.643c0.578,2.14-0.758,3.396-2.216,4.702l-0.644,0.253l-0.192,0.075l-0.064,0.025 l0.605-0.545c0.307-0.274,0.654-0.585,0.979-0.91c0.375-0.375,0.646-0.706,0.853-1.041c0.322-0.522,0.479-1.044,0.479-1.598 c0-0.246-0.039-0.524-0.116-0.825c-0.024-0.096-0.055-0.203-0.089-0.305l0.03,0.013l0.088,0.035L48.519,50.643z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.2356,
    y1: 41.5444,
    x2: 40.3001,
    y2: 42.7773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B3B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5703,
    style: {
      stopColor: "#B0B1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7646,
    style: {
      stopColor: "#A29F98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    style: {
      stopColor: "#98938A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAAAA9"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_85_)",
    d: "M21.295,40.619c0.121-0.105,0.297-0.118,0.432-0.034c0.506,0.323,0.872,0.559,1.465,0.805 c3.627,1.503,7.07,1.37,10.832,0.512c0.615-0.14,1.258-0.269,1.8-0.269c2.053,0,2.914,0.609,4.285,1.727 c0.132,0.108,0.172,0.293,0.095,0.446l-0.236-0.081l-0.067-0.072c0.005-0.01,0.002-0.022-0.006-0.03 c-0.562-0.458-1.006-0.82-1.65-1.162c-0.605-0.32-1.442-0.489-2.42-0.489c-0.508,0-1.129,0.125-1.725,0.261 c-1.855,0.423-3.481,0.637-4.834,0.637c-1.477,0-2.756-0.132-3.91-0.404c-0.929-0.219-1.681-0.508-2.294-0.762 c-0.633-0.262-1.105-0.567-1.387-0.749l-0.128-0.082c-0.004-0.003-0.008-0.004-0.013-0.004c-0.006,0-0.011,0.002-0.016,0.006 l-0.091-0.039L21.295,40.619z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.0507,
    y1: 42.8922,
    x2: 40.1912,
    y2: 44.0293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AEB0AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    style: {
      stopColor: "#AFB1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_86_)",
    d: "M40.205,43.806c-0.077,0.153-0.25,0.231-0.414,0.189c-4.668-1.179-7.908,1.577-11.914,1.577 c-1.859,0-3.535-0.693-4.845-2.003c-0.793-0.793-1.329-1.401-1.83-2.527c-0.065-0.146-0.027-0.318,0.094-0.423l0.159,0.183 l0.048,0.055l0.016,0.018c-0.008,0.007-0.011,0.018-0.006,0.028c0.148,0.333,0.452,0.885,0.746,1.295 c0.295,0.411,0.739,0.855,1.014,1.13c1.245,1.245,2.838,1.904,4.605,1.904c1.52,0,3.057-0.456,4.685-0.939l0.127-0.038 c1.076-0.319,2.092-0.621,3.258-0.794c0.42-0.062,1.004-0.103,1.489-0.103c0.156,0,0.306,0.004,0.445,0.013 c0.729,0.047,1.418,0.148,1.993,0.294c0.002,0.001,0.004,0.001,0.006,0.001c0.009,0,0.018-0.005,0.022-0.013l0.022,0.011 l0.065,0.033L40.205,43.806z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.4106,
    y1: 33.3537,
    x2: 42.4685,
    y2: 33.7836
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    style: {
      stopColor: "#918B82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#928E8E"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_87_)",
    d: "M42.494,33.662c-0.052-0.045-0.116-0.076-0.187-0.087c-0.318-0.047-0.648-0.098-0.968-0.188 c-0.082-0.023-0.595-0.173-0.673-0.173c-0.09,0-0.178,0.033-0.246,0.096l0.135,0.22l0.095,0.031 c0.004-0.004,0.01-0.006,0.016-0.006c0.002,0,0.582,0.161,0.582,0.161c0.23,0.064,0.551,0.129,0.86,0.175l0.151,0.022 c0.006,0.001,0.011,0.004,0.015,0.008l0.088-0.038L42.494,33.662z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.2742,
    y1: 34.2096,
    x2: 44.733,
    y2: 34.2096
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3181,
    style: {
      stopColor: "#AEB0AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#9B9C9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    style: {
      stopColor: "#9C9890"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9596,
    style: {
      stopColor: "#AAA9A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_88_)",
    d: "M44.512,33.391c-0.142,0.123-0.126,0.268-0.135,0.456c-0.011,0.218-0.102,0.418-0.263,0.581 c-0.167,0.169-0.393,0.261-0.635,0.261c-0.242,0-0.468-0.094-0.638-0.264c-0.085-0.085-0.145-0.181-0.199-0.422l-0.033-0.147 c-0.017-0.077-0.058-0.144-0.115-0.194l-0.159,0.183l-0.043,0.061l-0.018,0.014c0.004,0.004,0.006,0.008,0.007,0.014 c0.067,0.367,0.149,0.562,0.319,0.732c0.234,0.234,0.546,0.363,0.878,0.363c0.333,0,0.644-0.128,0.876-0.362 c0.222-0.223,0.347-0.501,0.362-0.803l0.01-0.197c0-0.006,0.003-0.011,0.007-0.015l-0.04-0.092L44.512,33.391z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.6314,
    y1: 33.4598,
    x2: 44.5148,
    y2: 33.5041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8B8379"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    style: {
      stopColor: "#918B82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#928E8E"
    }
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_89_)",
    d: "M46.631,33.457c-0.064-0.078-0.158-0.127-0.259-0.133c-0.566-0.035-0.859-0.062-1.442-0.032 c-0.164,0.008-0.297-0.007-0.418,0.099l0.155,0.187l0.048,0.055l0.018,0.018c0.004-0.004,0.009-0.006,0.015-0.007 c0.233-0.017,0.459-0.024,0.664-0.024c0.167,0,0.32,0.005,0.451,0.013l0.488,0.03c0.007,0.001,0.014,0.004,0.018,0.01l0.093-0.03 L46.631,33.457z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.7233,
    y1: 35.0845,
    x2: 40.3126,
    y2: 35.1293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4B6B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2392,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B4B6B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2B3B1"
    }
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_90_)",
    d: "M46.631,33.457c0.073,0.09,0.099,0.209,0.071,0.32c-0.229,0.899-0.444,1.556-1.121,2.231 c-1.764,1.765-4.663,0.908-5.19-1.911l-0.084-0.452c-0.023-0.124,0.019-0.25,0.112-0.335l0.164,0.179l0.049,0.054l0.016,0.018 c-0.006,0.006-0.009,0.014-0.007,0.022l0.084,0.452c0.168,0.901,0.594,1.48,0.922,1.808c0.472,0.473,1.084,0.734,1.723,0.734 c0.575,0,1.259-0.096,1.971-0.808c0.314-0.313,0.706-0.798,0.955-1.777l0.076-0.297c0.002-0.007,0-0.014-0.004-0.02l0.02-0.014 l0.059-0.042L46.631,33.457z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.0035,
    y1: 33.8948,
    x2: 59.5343,
    y2: 34.9832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0146,
    style: {
      stopColor: "#98938A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4742,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AEB0AE"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_91_)",
    points: "59.565,34.664 59.274,34.047 59.016,33.954 58.861,33.965 59.375,35.061 59.498,34.933  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.8299,
    y1: 33.9078,
    x2: 63.6909,
    y2: 31.2795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AEB0AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    style: {
      stopColor: "#AFB1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_92_)",
    d: "M63.127,31.809c-1.764,0.466-3.328,1.767-3.853,2.238l-0.295-0.058l-0.089-0.017l-0.03-0.007 c0.274-0.266,2.488-2.307,4.865-2.622l-0.173,0.188L63.127,31.809z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.6336,
    y1: 35.3181,
    x2: 63.6598,
    y2: 31.2777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AEB0AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    style: {
      stopColor: "#AFB1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_93_)",
    d: "M63.127,31.809c-0.694,1.119-1.999,2.425-3.562,2.856l-0.135,0.285l-0.041,0.084l-0.014,0.028 c1.041-0.225,1.997-0.768,2.842-1.613c1.016-1.016,1.447-1.831,1.508-2.105l-0.034,0.029l-0.11,0.091L63.127,31.809z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.8609,
    y1: 41.0856,
    x2: 51.0378,
    y2: 43.3828
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B3B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#B5B7B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#B5B7B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5703,
    style: {
      stopColor: "#B0B1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7646,
    style: {
      stopColor: "#A29F98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#979289"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    style: {
      stopColor: "#98938A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAAAA9"
    }
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_94_)",
    d: "M49.454,43.065c-1.051-0.021-1.516-0.887-2.617-1.947l-1.297-0.522l-0.522,0.065 c1.01,0.122,1.321,0.435,1.784,0.902l0.089,0.09c0.139,0.139,0.275,0.284,0.409,0.429c0.132,0.142,0.264,0.283,0.399,0.418 c0.513,0.513,0.972,0.906,1.799,0.906c0.205,0,0.425-0.03,0.651-0.09c0.392-0.107,0.757-0.265,1.088-0.47l-0.599,0.188 L49.454,43.065z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.996,
    y1: 40.7223,
    x2: 51.173,
    y2: 43.0195
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AAAAA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#AEB0AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2614,
    style: {
      stopColor: "#AFB1AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#B6B8B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B7B4"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_95_)",
    d: "M49.454,43.065c-1.182-0.49-1.617-1.375-2.617-1.947l-1.396-0.486l-0.327,0.016l-0.096,0.012 c0.254-0.108,0.525-0.162,0.807-0.162c0.969,0,1.602,0.577,2.273,1.187c0.682,0.621,1.387,1.262,2.48,1.262 c0.22,0,0.441-0.035,0.659-0.103l-0.168,0.071l-0.431,0.128L49.454,43.065z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "contrast_lines"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "inner_contrast_line_1_",
    cx: 24.7695,
    cy: 24.0419,
    r: 80.3492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404142"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#3D3E3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2667,
    style: {
      stopColor: "#3A3C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#333534"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#2C2E2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7024,
    style: {
      stopColor: "#25272C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#1E2029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8959,
    style: {
      stopColor: "#1A1A22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9643,
    style: {
      stopColor: "#100B0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090100"
    }
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "inner_contrast_line_6_",
    fill: "url(#inner_contrast_line_1_)",
    d: "M77.938,10.037c1.076,0.888,2.114,1.828,3.109,2.823 c6.504,6.504,10.754,14.838,12.254,23.791c1.23-1.386,2.485-2.749,3.767-4.083C94.997,23.97,90.593,16.027,84.237,9.67 c-0.289-0.289-0.582-0.574-0.877-0.855C81.563,9.26,79.754,9.665,77.938,10.037z M79.154,14.753 c-1.474-1.474-3.05-2.825-4.709-4.046c-8.015,1.432-16.192,2.17-24.445,2.17c-8.254,0-16.43-0.738-24.446-2.17 c-1.659,1.221-3.234,2.572-4.709,4.046c-6.648,6.648-10.789,15.334-11.82,24.589c5.246,6.225,9.973,12.936,14.099,20.082 c4.126,7.147,7.575,14.596,10.342,22.251c5.164,2.26,10.786,3.462,16.532,3.462c5.746,0,11.368-1.201,16.532-3.462 c2.767-7.655,6.216-15.104,10.342-22.251c4.126-7.147,8.853-13.858,14.099-20.082C89.943,30.087,85.802,21.402,79.154,14.753z  M28.808,8.54C35.775,9.637,42.858,10.2,50,10.2c7.141,0,14.224-0.563,21.191-1.659C64.841,4.736,57.527,2.677,50,2.677 C42.473,2.677,35.158,4.736,28.808,8.54z M6.699,36.651c1.5-8.953,5.75-17.287,12.254-23.791c0.995-0.995,2.033-1.935,3.109-2.823 c-1.816-0.373-3.625-0.778-5.422-1.222c-0.296,0.281-0.588,0.566-0.877,0.855c-6.357,6.357-10.76,14.3-12.831,22.898 C4.214,33.902,5.469,35.265,6.699,36.651z M29.963,79.938c-2.534-6.579-5.587-12.993-9.156-19.175 c-3.569-6.182-7.598-12.03-12.029-17.513c-0.003,0.219-0.008,0.437-0.008,0.657c0,10.935,4.344,21.422,12.076,29.154 C23.575,75.791,26.649,78.096,29.963,79.938z M65.366,85.034c-4.869,1.819-10.068,2.78-15.366,2.78 c-5.298,0-10.497-0.961-15.366-2.78c0.586,1.759,1.139,3.527,1.653,5.305C40.7,91.643,45.315,92.326,50,92.326 c4.685,0,9.3-0.682,13.714-1.986C64.228,88.562,64.781,86.793,65.366,85.034z M91.222,43.251 c-4.432,5.482-8.46,11.331-12.029,17.512c-3.569,6.183-6.622,12.596-9.156,19.175c3.314-1.843,6.388-4.148,9.117-6.877 c7.732-7.732,12.076-18.219,12.076-29.154C91.23,43.688,91.225,43.47,91.222,43.251z M83.392,8.713 c0.308,0.292,0.613,0.588,0.914,0.889c6.381,6.381,10.797,14.357,12.868,22.99c-1.337,1.389-2.643,2.809-3.923,4.255 c-1.47-9.006-5.725-17.393-12.261-23.929c-1.036-1.036-2.119-2.015-3.244-2.934C79.638,9.597,81.521,9.176,83.392,8.713z  M91.074,39.366c-5.255,6.23-9.988,12.949-14.12,20.105c-4.131,7.155-7.583,14.614-10.351,22.28 C61.418,84.026,55.772,85.234,50,85.234c-5.772,0-11.418-1.209-16.603-3.483c-2.768-7.666-6.22-15.125-10.351-22.28 c-4.131-7.155-8.865-13.874-14.12-20.105c1.027-9.29,5.179-18.009,11.851-24.682c1.486-1.486,3.075-2.847,4.748-4.076 C33.55,12.044,41.736,12.785,50,12.785c8.264,0,16.45-0.74,24.474-2.176c1.673,1.23,3.262,2.59,4.748,4.076 C85.895,21.357,90.047,30.076,91.074,39.366z M50,2.58c7.626,0,15.034,2.11,21.447,6.003C64.398,9.706,57.229,10.28,50,10.28 c-7.229,0-14.398-0.575-21.447-1.697C34.966,4.69,42.373,2.58,50,2.58z M2.826,32.591c2.071-8.633,6.487-16.609,12.868-22.99 c0.301-0.301,0.606-0.597,0.914-0.889c1.871,0.463,3.754,0.885,5.645,1.27c-1.124,0.92-2.207,1.898-3.244,2.934 C12.475,19.453,8.22,27.84,6.749,36.846C5.469,35.4,4.163,33.98,2.826,32.591z M20.777,73.13 c-7.75-7.75-12.104-18.262-12.104-29.223c0-0.302,0.005-0.603,0.011-0.904c4.497,5.542,8.579,11.461,12.193,17.72 c3.613,6.259,6.7,12.753,9.252,19.418C26.726,78.274,23.571,75.924,20.777,73.13z M63.786,90.42 C59.35,91.735,54.711,92.423,50,92.423c-4.711,0-9.35-0.688-13.786-2.003c-0.535-1.852-1.111-3.693-1.723-5.525 C39.4,86.753,44.649,87.734,50,87.734c5.351,0,10.6-0.981,15.509-2.839C64.897,86.726,64.321,88.568,63.786,90.42z M91.327,43.907 c0,10.961-4.354,21.472-12.104,29.223c-2.794,2.794-5.948,5.144-9.352,7.01c2.552-6.664,5.639-13.159,9.252-19.418 c3.614-6.259,7.696-12.178,12.193-17.72C91.322,43.304,91.327,43.606,91.327,43.907z M66.079,29.835l0.196-0.58h-0.613 c-3.118,0-6.342,1.613-8.415,4.208l-0.897-0.71c0.087-0.111,1.206-1.5,3.111-2.729l-0.308-0.012L43.25,30.011l-0.024,0.015 c-0.406,0.253-0.739,0.515-1.021,0.8c-0.356,0.333-0.857,0.905-1.165,1.428c0.501,0.293,1.014,0.379,1.491,0.379 c0.722,0,1.136-0.119,1.645-0.202c0.437-0.071,0.885-0.13,1.501-0.106c0.247,0.01,0.49,0.033,0.727,0.072 c0.427,0.07,0.834,0.186,1.208,0.333c0.636,0.252,1.178,0.6,1.567,0.989c0.037,0.037,0.072,0.073,0.105,0.111L48.3,34.708 c-0.043-0.05-0.096-0.097-0.156-0.149c-0.109-0.094-0.221-0.171-0.331-0.229c-0.176-0.092-0.275-0.139-0.392-0.173l-0.018-0.005 c-0.013,0.204-0.134,0.472-0.296,0.835c-0.2,0.448-0.51,1.016-1.017,1.523c-0.875,0.875-1.754,1.144-2.676,1.144 c-2.053,0-3.833-1.706-3.876-4.666c-0.596-0.331-2.042-1.028-3.648-1.028c-0.661,0-1.288,0.118-1.861,0.35 c-1.102,0.446-2.05,1.329-2.819,2.622c-0.231,0.388-0.443,0.815-0.65,1.307c-0.244,0.58-0.429,1.082-0.599,1.629l-0.147,0.472 l0.449-0.207c0.636-0.294,1.086-0.492,1.643-0.695c1.012-0.369,1.901-0.548,2.716-0.548c1.109,0,2.064,0.322,2.839,0.956 c0.057,0.047,0.153,0.155,0.265,0.281c0.549,0.618,1.692,1.903,3.801,2.457c3.897,1.024,3.93,2.081,3.965,3.201 c-0.003,0.068-0.169,0.481-0.924,1.236c-0.503,0.503-1.143,1.034-1.902,1.579c-1.818,1.306-3.317,2.115-5.167,2.115 c-0.629,0-1.277-0.093-2.04-0.293c-0.223-0.058-0.483-0.136-0.71-0.21c-0.107-0.035-1.024-0.368-1.132-0.412 c0.038,0.109,0.131,0.327,0.173,0.418c0.085,0.185,0.217,0.429,0.314,0.597c0.138,0.239,0.301,0.449,0.511,0.659 c0.915,0.915,2.424,1.36,4.612,1.36c1.543,0,2.377-0.117,4.202-0.373c0.386-0.054,0.818-0.115,1.31-0.182 c-0.323,0.136-0.626,0.263-0.91,0.381c-2.972,1.244-3.972,1.663-5.275,2.965c-1.378,1.378-2.077,3.009-2.077,4.846 c0,0.52,0.069,1.022,0.164,1.632c0.015,0.099,0.09,0.445,0.09,0.445s0.233-0.256,0.303-0.326c0.744-0.744,1.486-1.354,2.206-1.812 c0.724-0.461,1.469-0.804,2.278-1.048c0.45-0.135,0.895-0.245,1.361-0.335c0.121-0.023,0.245-0.046,0.373-0.068 c-1.156,1.183-3.825,4.151-3.825,8.577c0,0.786,0.098,1.572,0.29,2.336c0.17,0.676,0.418,1.351,0.738,2.008 c0.49,1.005,1.153,1.981,2.013,2.96c0.242,0.276,0.507,0.572,0.781,0.849c0.077,0.078,0.377,0.408,0.377,0.408 s0.009-0.372,0.013-0.502c0.009-0.238,0.032-0.566,0.056-0.813c0.073-0.728,0.141-1.416,0.288-2.239 c0.481-2.684,1.279-4.6,2.373-5.694l0.086-0.087c0.188-0.191,0.461-0.469,0.878-0.776l0.11,0.407c0.524,1.925,1.4,5.148,1.4,8.668 c0,0.281-0.016,2.557-0.53,4.452c-0.062,0.228-0.135,0.472-0.226,0.671c-0.047,0.103-0.139,0.306-0.185,0.363 c0,0,0.352-0.057,0.45-0.074c0.836-0.138,1.676-0.397,2.718-0.915c1.169-0.581,2.135-1.36,2.869-2.314 c1.188-1.543,1.79-3.556,1.79-5.984c0-2.25-0.41-3.915-0.772-5.384l-0.078-0.318c3.324,0.906,5.4,3.876,5.302,7.613 c-0.004,0.14-0.041,0.388-0.086,0.502c0.061-0.046,0.337-0.239,0.42-0.296c0.728-0.494,1.159-0.902,1.648-1.391 c1.037-1.037,1.809-2.199,2.296-3.455c0.393-1.014,0.592-2.077,0.592-3.16c0-3.313-1.75-6.011-2.909-7.796l-0.024-0.037 c0.221-0.02,0.476-0.037,0.767-0.037c1.739,0,4.111,0.631,5.532,3.636c0.085,0.181,0.15,0.381,0.184,0.521 c0.049-0.143,0.169-0.417,0.216-0.527c0.588-1.357,0.886-2.896,0.886-4.575c0-1.579-0.245-3.007-0.749-4.367 c-0.667-1.799-1.774-3.434-3.485-5.145c-0.561-0.561-1.188-1.134-1.966-1.797c0.473-0.16,1.417-0.422,2.512-0.422 c1.123,0,2.131,0.27,2.995,0.804c0.085,0.053,0.349,0.268,0.474,0.42c-0.054-0.266-0.122-0.557-0.144-0.654 c-0.737-3.33-2.824-5.83-5.913-7.337c-1.209,1.052-2.542,1.931-4.611,2.315c0,0-0.131-0.637-0.213-1.032l-0.019-0.091 C63.459,36.158,65.45,31.7,66.079,29.835z M27.876,45.208c-1.761,0-3.347-0.656-4.588-1.897c-0.27-0.27-0.714-0.712-1.011-1.127 c-0.283-0.394-0.587-0.939-0.743-1.291c0.25,0.156,0.774,0.524,1.519,0.833c0.699,0.29,1.43,0.559,2.297,0.763 c1.155,0.273,2.435,0.405,3.915,0.405c1.355,0,2.983-0.215,4.84-0.638c0.594-0.135,1.214-0.26,1.719-0.26 c0.898,0,1.768,0.148,2.408,0.487c0.64,0.339,1.089,0.705,1.646,1.159c-0.637-0.161-1.341-0.252-1.998-0.294 c-0.598-0.038-1.42,0.013-1.939,0.09c-1.169,0.173-2.186,0.475-3.262,0.795l-0.126,0.037 C30.928,44.753,29.392,45.208,27.876,45.208z M45.412,33.644c0.166,0,0.319,0.005,0.45,0.013l0.488,0.03l-0.076,0.297 c-0.248,0.973-0.638,1.455-0.949,1.766c-0.706,0.706-1.384,0.801-1.954,0.801c-0.632,0-1.238-0.258-1.706-0.727 c-0.325-0.325-0.748-0.9-0.915-1.795l-0.084-0.452l0.575,0.16c0.229,0.064,0.552,0.13,0.863,0.175l0.149,0.022l0.033,0.147 c0.063,0.282,0.147,0.45,0.296,0.6c0.239,0.239,0.557,0.37,0.896,0.37c0.34,0,0.657-0.131,0.893-0.369 c0.226-0.227,0.353-0.511,0.369-0.819l0.01-0.198l0.198-0.01C45.11,33.648,45.267,33.644,45.412,33.644z M59.471,39.786 l-0.554,1.734c0.351,0.408,0.615,0.787,0.835,1.112c0.605,0.891,0.988,1.704,1.203,2.559c0.209,0.83,0.238,1.63,0.238,2.371 c0,0.592-0.065,1.188-0.193,1.773c-0.092,0.421-0.223,0.877-0.329,1.219c-0.103,0.333-0.33,0.944-0.33,0.944 s-0.031-0.689-0.094-1.062c-0.063-0.373-0.121-0.775-0.221-1.1c-0.306-0.997-0.801-1.843-1.473-2.515 c-0.417-0.417-0.908-0.772-1.46-1.058c-0.467-0.242-0.865-0.39-1.181-0.492c0.092,0.346,0.186,0.724,0.291,1.173 c0.266,1.148,0.39,2.094,0.39,2.979c0,1.402-0.316,2.589-0.967,3.629c-0.22,0.351-0.482,0.679-0.779,0.975 c-0.281,0.281-0.527,0.53-0.807,0.747c-0.355,0.276-0.513,0.387-0.801,0.569c0.149-0.247,0.271-0.507,0.413-0.802 c0.176-0.366,0.285-0.748,0.366-1.033c0.776-2.741-0.508-4.433-1.542-5.467c-0.147-0.148-0.289-0.283-0.43-0.409 c-0.016,0.381-0.032,0.766-0.059,1.154c-0.091,1.325-0.335,2.83-1.455,3.95c-0.158,0.158-0.353,0.352-0.58,0.539 c-0.216,0.178-0.465,0.386-0.795,0.589c0.14-0.27,0.256-0.405,0.459-0.913c0.202-0.507,0.286-1.025,0.286-1.473 c0-0.557-0.119-0.996-0.222-1.315c-0.053-0.164-0.115-0.319-0.184-0.461l-1.413,0.76c0.036,0.107,0.069,0.22,0.095,0.321 c0.077,0.299,0.116,0.575,0.116,0.82c0,0.549-0.156,1.068-0.475,1.585c-0.206,0.333-0.476,0.663-0.85,1.037 c-0.325,0.325-0.672,0.635-0.978,0.909l-0.652,0.588l0.581-0.006c0.628-0.007,1.462-0.035,2.347-0.194 c1.416-0.255,2.523-0.798,3.386-1.662c0.347-0.347,0.653-0.749,0.912-1.197c-0.042,0.455-0.158,0.921-0.354,1.415 c-0.224,0.565-0.548,1.159-0.994,1.815c-0.27,0.398-0.575,0.833-0.967,1.313l-0.357,0.436l0.558-0.08 c0.674-0.096,1.347-0.234,2.001-0.411c1.266-0.342,3.109-1.05,4.492-3.236c0.416-0.658,0.713-1.345,0.908-2.1 c0.192-0.743,0.286-1.551,0.286-2.473c0-0.137-0.005-0.281-0.013-0.428c0.123,0.215,0.237,0.453,0.343,0.716 c0.228,0.566,0.378,1.206,0.457,1.957c0.049,0.469,0.072,0.98,0.072,1.606v0.124c0,0.604,0.001,1.174-0.047,1.82l-0.046,0.631 l0.428-0.467c0.559-0.612,1.162-1.313,1.779-2.288c1.121-1.771,1.689-3.703,1.689-5.743c0-0.895-0.099-1.713-0.303-2.501 c-0.285-1.103-0.775-2.137-1.497-3.164c-0.455-0.647-0.917-1.2-1.453-1.74C59.52,39.836,59.505,39.82,59.471,39.786z  M45.826,40.475c-0.305,0-0.61,0.064-0.898,0.201c1.138,0.12,1.424,0.471,1.947,0.994c0.277,0.277,0.536,0.575,0.808,0.847 c0.503,0.503,0.964,0.913,1.816,0.913c0.202,0,0.42-0.028,0.657-0.091c0.467-0.128,0.89-0.324,1.267-0.587 c-0.291,0.12-0.573,0.172-0.845,0.172C48.448,42.924,47.816,40.475,45.826,40.475z M63.757,31.314 c-2.588,0.33-4.925,2.647-4.925,2.647l0.53,1.127c1.222-0.259,2.173-0.923,2.873-1.624C63.271,32.429,63.683,31.644,63.757,31.314z  M43.225,29.97c0.008-0.005,0.016-0.007,0.025-0.007l15.904,0.001l0.31,0.012c0.021,0.001,0.04,0.015,0.045,0.036 c0.006,0.02-0.003,0.042-0.021,0.054c-1.777,1.146-2.873,2.44-3.069,2.681l0.821,0.65c2.083-2.585,5.305-4.189,8.423-4.189h0.613 c0.016,0,0.03,0.008,0.039,0.02c0.009,0.013,0.012,0.029,0.007,0.044l-0.196,0.58c-0.63,1.868-2.618,6.322-7.491,7.44l0.212,1.029 c2.139-0.406,3.446-1.343,4.541-2.295c0.009-0.008,0.02-0.012,0.032-0.012c0.007,0,0.014,0.002,0.021,0.005 c3.158,1.541,5.212,4.09,5.939,7.37l0.021,0.093c0.031,0.135,0.081,0.356,0.123,0.562c0.004,0.022-0.007,0.044-0.027,0.053 c-0.007,0.003-0.014,0.005-0.021,0.005c-0.014,0-0.028-0.006-0.038-0.018c-0.118-0.143-0.377-0.357-0.462-0.409 c-0.856-0.529-1.855-0.797-2.969-0.797c-1.031,0-1.928,0.234-2.415,0.392c0.751,0.643,1.357,1.198,1.903,1.744 c1.716,1.716,2.827,3.356,3.496,5.163c0.506,1.366,0.752,2.8,0.752,4.384c0,1.685-0.3,3.23-0.891,4.594 c-0.064,0.148-0.169,0.392-0.215,0.524c-0.007,0.02-0.025,0.033-0.046,0.033c0,0-0.001,0-0.002,0 c-0.021-0.001-0.04-0.016-0.045-0.037c-0.041-0.167-0.108-0.358-0.181-0.512c-1.41-2.982-3.763-3.608-5.489-3.608 c-0.22,0-0.438,0.009-0.682,0.03c1.162,1.79,2.897,4.482,2.897,7.791c0,1.089-0.2,2.158-0.595,3.178 c-0.489,1.262-1.265,2.43-2.306,3.472c-0.465,0.465-0.91,0.891-1.655,1.397c-0.082,0.056-0.357,0.248-0.418,0.294 c-0.009,0.007-0.019,0.01-0.029,0.01c-0.01,0-0.021-0.003-0.029-0.01c-0.017-0.013-0.024-0.036-0.016-0.056 c0.042-0.106,0.079-0.348,0.082-0.486c0.096-3.667-1.936-6.618-5.186-7.542l0.059,0.238c0.363,1.474,0.773,3.141,0.773,5.395 c0,2.438-0.606,4.461-1.8,6.013c-0.739,0.96-1.709,1.744-2.886,2.328c-0.977,0.486-1.82,0.77-2.732,0.92 c0,0-0.455,0.074-0.458,0.074c-0.017,0-0.033-0.009-0.042-0.024c-0.01-0.017-0.009-0.039,0.004-0.055 c0.039-0.049,0.123-0.232,0.168-0.331c0.105-0.228,0.179-0.485,0.234-0.686c0.514-1.894,0.529-4.184,0.529-4.439 c0-3.515-0.875-6.733-1.398-8.655l-0.091-0.338c-0.382,0.289-0.641,0.552-0.815,0.728l-0.086,0.087 c-1.087,1.087-1.881,2.994-2.36,5.669c-0.147,0.82-0.215,1.506-0.287,2.232c-0.025,0.249-0.047,0.575-0.056,0.813 c-0.005,0.13-0.014,0.502-0.014,0.502c-0.001,0.02-0.013,0.038-0.032,0.044c-0.006,0.002-0.011,0.003-0.017,0.003 c-0.013,0-0.027-0.006-0.036-0.016c0,0-0.298-0.329-0.375-0.407c-0.284-0.286-0.553-0.589-0.783-0.851 c-0.865-0.984-1.526-1.956-2.02-2.97c-0.321-0.659-0.571-1.338-0.742-2.017c-0.194-0.768-0.292-1.558-0.292-2.348 c0-3.065,1.256-5.925,3.735-8.504c-0.076,0.013-0.152,0.028-0.225,0.042c-0.466,0.09-0.91,0.199-1.357,0.334 c-0.804,0.242-1.545,0.583-2.266,1.042c-0.716,0.456-1.456,1.064-2.197,1.806c-0.07,0.07-0.302,0.325-0.302,0.325 c-0.009,0.01-0.022,0.016-0.036,0.016c-0.004,0-0.008-0.001-0.013-0.002c-0.018-0.005-0.031-0.019-0.035-0.037 c0,0-0.075-0.349-0.09-0.448c-0.09-0.576-0.165-1.098-0.165-1.64c0-1.851,0.704-3.493,2.091-4.881 c1.309-1.309,2.312-1.729,5.289-2.975l0.571-0.239c-0.298,0.041-0.944,0.132-0.944,0.132c-1.828,0.256-2.662,0.373-4.209,0.373 c-2.202,0-3.722-0.45-4.647-1.374c-0.213-0.214-0.378-0.427-0.519-0.669c-0.097-0.169-0.231-0.415-0.316-0.601 c-0.042-0.092-0.136-0.313-0.175-0.423c-0.006-0.018-0.002-0.038,0.012-0.051c0.009-0.009,0.021-0.013,0.033-0.013 c0.006,0,0.012,0.001,0.018,0.004c0.101,0.041,1.019,0.375,1.129,0.411c0.226,0.073,0.485,0.151,0.707,0.209 c0.759,0.198,1.403,0.291,2.027,0.291c1.838,0,3.329-0.806,5.139-2.106c0.757-0.544,1.395-1.074,1.895-1.574 c0.735-0.735,0.907-1.143,0.91-1.204c-0.035-1.097-0.068-2.137-3.929-3.152c-2.124-0.558-3.273-1.851-3.825-2.472 c-0.111-0.125-0.206-0.232-0.26-0.276c-0.766-0.627-1.711-0.945-2.809-0.945c-0.81,0-1.693,0.178-2.7,0.545 c-0.555,0.202-1.005,0.4-1.64,0.693l-0.449,0.207c-0.007,0.003-0.013,0.004-0.02,0.004c-0.012,0-0.023-0.004-0.032-0.012 c-0.014-0.013-0.02-0.033-0.014-0.051l0.147-0.472c0.171-0.548,0.356-1.051,0.601-1.633c0.208-0.494,0.421-0.923,0.653-1.313 c0.775-1.303,1.731-2.192,2.843-2.642c0.579-0.235,1.212-0.354,1.879-0.354c1.633,0,3.112,0.723,3.672,1.034 c0.015,0.008,0.025,0.024,0.025,0.042c0.039,2.719,1.612,4.618,3.827,4.618c1.031,0,1.871-0.359,2.642-1.13 c0.407-0.407,0.736-0.9,1.007-1.508c0.166-0.372,0.279-0.627,0.292-0.818c0.001-0.015,0.009-0.028,0.021-0.037 c0.008-0.006,0.018-0.009,0.028-0.009c0.005,0,0.009,0.001,0.014,0.002c0.138,0.04,0.239,0.088,0.418,0.181 c0.114,0.06,0.229,0.139,0.34,0.235c0.047,0.04,0.09,0.079,0.127,0.117l0.912-0.813c-0.023-0.024-0.047-0.048-0.071-0.073 c-0.395-0.395-0.932-0.733-1.551-0.978c-0.385-0.152-0.788-0.264-1.198-0.331c-0.232-0.038-0.475-0.062-0.721-0.072 c-0.094-0.004-0.184-0.005-0.27-0.005c-0.495,0-0.875,0.055-1.221,0.111c-0.12,0.019-0.234,0.041-0.348,0.062 c-0.368,0.069-0.748,0.14-1.305,0.14c-0.575,0-1.07-0.126-1.515-0.386c-0.011-0.006-0.019-0.017-0.023-0.03 c-0.003-0.012-0.001-0.026,0.005-0.037c0.311-0.528,0.814-1.103,1.174-1.439C42.465,30.495,42.81,30.226,43.225,29.97z  M32.568,44.317l0.127-0.038c1.075-0.319,2.09-0.62,3.255-0.793c0.419-0.062,1.002-0.103,1.485-0.103 c0.155,0,0.305,0.004,0.443,0.013c0.727,0.047,1.415,0.148,1.989,0.293c0.004,0.001,0.008,0.002,0.012,0.002 c0.018,0,0.035-0.01,0.043-0.027c0.01-0.02,0.005-0.045-0.013-0.059c-0.563-0.459-1.008-0.822-1.654-1.164 c-0.769-0.407-1.746-0.492-2.431-0.492c-0.511,0-1.133,0.126-1.73,0.262c-1.853,0.423-3.477,0.637-4.829,0.637 c-1.475,0-2.752-0.132-3.904-0.404c-0.928-0.219-1.678-0.507-2.29-0.761c-0.631-0.262-1.102-0.566-1.384-0.747l-0.128-0.082 c-0.008-0.005-0.017-0.007-0.026-0.007c-0.011,0-0.023,0.004-0.032,0.012c-0.016,0.014-0.021,0.037-0.013,0.056 c0.149,0.335,0.453,0.888,0.748,1.299c0.296,0.413,0.741,0.857,1.016,1.133c1.25,1.25,2.848,1.911,4.622,1.911 C29.4,45.257,30.939,44.8,32.568,44.317z M45.359,35.785c0.316-0.315,0.711-0.803,0.962-1.788l0.076-0.297 c0.004-0.014,0.001-0.029-0.008-0.041c-0.009-0.012-0.022-0.019-0.036-0.02l-0.488-0.03c-0.132-0.008-0.285-0.013-0.453-0.013 c-0.146,0-0.303,0.004-0.465,0.012l-0.198,0.01c-0.025,0.001-0.045,0.021-0.046,0.046l-0.01,0.198 c-0.015,0.297-0.137,0.569-0.355,0.787c-0.227,0.229-0.532,0.354-0.859,0.354c-0.326,0-0.631-0.126-0.861-0.356 c-0.143-0.143-0.222-0.305-0.283-0.577l-0.033-0.147c-0.004-0.019-0.02-0.034-0.04-0.037l-0.149-0.022 c-0.308-0.045-0.629-0.11-0.857-0.174l-0.575-0.16c-0.004-0.001-0.009-0.002-0.013-0.002c-0.012,0-0.024,0.004-0.033,0.013 c-0.012,0.011-0.018,0.028-0.015,0.045l0.084,0.452c0.169,0.907,0.598,1.491,0.928,1.82c0.477,0.478,1.095,0.741,1.74,0.741 C43.951,36.6,44.641,36.503,45.359,35.785z M50.29,57.236c0.396-0.484,0.7-0.918,0.97-1.316c0.446-0.658,0.773-1.254,0.998-1.824 c0.198-0.501,0.315-0.968,0.357-1.428c0.002-0.023-0.012-0.044-0.033-0.051c-0.005-0.002-0.01-0.002-0.015-0.002 c-0.017,0-0.033,0.009-0.042,0.024c-0.257,0.444-0.561,0.844-0.905,1.187c-0.855,0.856-1.955,1.395-3.36,1.648 c-0.881,0.158-1.713,0.186-2.339,0.193l-0.452,0.005l0.557-0.502c0.307-0.275,0.654-0.585,0.98-0.911 c0.376-0.377,0.648-0.709,0.857-1.046c0.325-0.525,0.482-1.052,0.482-1.611c0-0.248-0.039-0.528-0.117-0.832 c-0.023-0.09-0.051-0.189-0.083-0.286l1.332-0.717c0.059,0.128,0.113,0.265,0.16,0.409c0.102,0.317,0.219,0.75,0.219,1.301 c0,0.341-0.049,0.87-0.283,1.455c-0.141,0.353-0.239,0.523-0.334,0.688c-0.041,0.071-0.081,0.14-0.123,0.221 c-0.01,0.019-0.006,0.043,0.01,0.058c0.009,0.009,0.021,0.013,0.033,0.013c0.009,0,0.018-0.002,0.025-0.007 c0.325-0.2,0.569-0.402,0.785-0.58c0.252-0.208,0.461-0.417,0.599-0.555c1.131-1.131,1.377-2.647,1.469-3.981 c0.024-0.353,0.04-0.704,0.054-1.052c0.115,0.106,0.232,0.217,0.351,0.338c1.025,1.025,2.299,2.702,1.53,5.419 c-0.079,0.278-0.188,0.66-0.363,1.025l-0.034,0.072c-0.129,0.269-0.24,0.502-0.376,0.727c-0.011,0.019-0.008,0.044,0.008,0.06 c0.009,0.009,0.022,0.014,0.034,0.014c0.009,0,0.018-0.002,0.026-0.008c0.294-0.186,0.452-0.298,0.805-0.572 c0.27-0.21,0.505-0.445,0.777-0.717l0.034-0.034c0.299-0.299,0.563-0.63,0.785-0.984c0.656-1.047,0.975-2.243,0.975-3.655 c0-0.888-0.124-1.838-0.391-2.99c-0.096-0.413-0.183-0.765-0.268-1.088c0.384,0.129,0.732,0.276,1.088,0.461 c0.548,0.284,1.036,0.637,1.448,1.049c0.666,0.666,1.157,1.505,1.461,2.494c0.083,0.273,0.138,0.603,0.191,0.923l0.028,0.171 c0.062,0.366,0.093,1.049,0.094,1.056c0.001,0.023,0.018,0.042,0.041,0.046c0.003,0,0.005,0.001,0.008,0.001 c0.02,0,0.038-0.012,0.045-0.032c0.002-0.006,0.229-0.616,0.331-0.946c0.097-0.314,0.234-0.781,0.33-1.224 c0.129-0.588,0.194-1.188,0.194-1.784c0-0.744-0.029-1.548-0.239-2.383c-0.217-0.86-0.602-1.678-1.21-2.574 c-0.217-0.319-0.476-0.692-0.821-1.095l0.522-1.632l0.024,0.024c0.535,0.539,0.995,1.09,1.448,1.734 c0.718,1.022,1.205,2.051,1.489,3.148c0.203,0.784,0.301,1.599,0.301,2.489c0,2.03-0.566,3.953-1.682,5.717 c-0.616,0.973-1.216,1.671-1.774,2.281l-0.333,0.364l0.036-0.492c0.047-0.648,0.047-1.219,0.047-1.823v-0.125 c0-0.628-0.023-1.14-0.073-1.612c-0.08-0.756-0.23-1.4-0.46-1.97c-0.106-0.263-0.223-0.505-0.346-0.722 c-0.009-0.016-0.025-0.024-0.042-0.024c-0.004,0-0.009,0.001-0.014,0.002c-0.021,0.006-0.036,0.027-0.035,0.049 c0.008,0.146,0.013,0.289,0.013,0.425c0,0.916-0.093,1.721-0.284,2.46c-0.195,0.751-0.49,1.434-0.903,2.087 c-1.374,2.171-3.206,2.875-4.464,3.215c-0.655,0.177-1.326,0.314-1.995,0.41l-0.434,0.062L50.29,57.236z M49.499,43.381 c-0.82,0-1.256-0.372-1.782-0.899c-0.135-0.135-0.266-0.276-0.398-0.418c-0.135-0.145-0.27-0.29-0.41-0.429l-0.089-0.09 c-0.453-0.456-0.76-0.766-1.705-0.897c0.225-0.084,0.464-0.126,0.711-0.126c0.959,0,1.589,0.573,2.257,1.18 c0.685,0.624,1.394,1.269,2.497,1.269c0.164,0,0.327-0.019,0.49-0.056c-0.287,0.16-0.597,0.286-0.926,0.376 C49.919,43.351,49.702,43.381,49.499,43.381z M58.891,33.972c0.254-0.243,2.427-2.263,4.8-2.6 c-0.105,0.337-0.513,1.081-1.491,2.059c-0.836,0.837-1.782,1.376-2.811,1.602L58.891,33.972z M69.296,61.373 c0.837-1.451,1.725-3.681,1.725-6.861c0-1.562-0.204-3.36-0.918-5.229c-0.631-1.65-1.661-3.364-3.262-4.77 c-0.089-0.081-0.183-0.162-0.282-0.24c0.139,0.012,0.268,0.032,0.399,0.057c1.015,0.191,1.896,0.711,2.516,1.33 c0.525,0.525,0.934,1.166,1.31,1.883c0.152,0.289,0.394,0.794,0.394,0.794c0.039-0.389,0.033-0.512,0.045-0.85 c-0.085-5.63-1.656-9.748-6.775-12.411c-0.001-0.001-0.032-0.016-0.032-0.016c1.791-2.034,2.657-4.326,3.263-6.789 c-1.234-0.314-3.511-0.579-6.971,1.039c0,0,0.001-0.001,0.001-0.001l5.497-13.556c-1.503-0.227-3.226,0.935-3.635,2.39 c-0.209,0.74-0.078,1.543,0.269,2.162c-0.321-0.347-0.735-0.613-1.217-0.754c-1.428-0.417-3,0.403-3.328,1.88 c-0.37,1.665,0.366,2.992,1.683,3.427c0.559,0.163,0.737,0.187,1.327,0.088c-1.006,1.686-2.06,2.619-4.338,2.619 c-2.184,0-3.718-2.23-4.723-3.915c0,0,1.025,0.509,1.605,0.509c1.486,0,2.691-1.227,2.691-2.74c0-1.514-1.205-2.741-2.691-2.741 c-0.503,0-0.972,0.14-1.374,0.384c0.5-0.498,0.843-1.235,0.843-2.003c0-1.514-1.204-2.741-2.69-2.741 c-1.487,0-2.691,1.228-2.691,2.741c0,0.775,0.316,1.476,0.824,1.974c-0.393-0.228-0.87-0.354-1.355-0.354 c-1.487,0-2.691,1.227-2.691,2.741c0,1.514,1.204,2.74,2.691,2.74c0.587,0,1.159-0.184,1.602-0.509 c-1.005,1.685-2.523,3.934-4.707,3.934c-2.278,0-3.38-0.952-4.385-2.638c0.591,0.099,0.768,0.075,1.326-0.088 c1.317-0.435,2.053-1.762,1.684-3.427c-0.328-1.477-1.9-2.297-3.328-1.88c-0.483,0.141-0.897,0.407-1.216,0.754 c0.346-0.619,0.476-1.423,0.268-2.162c-0.41-1.455-2.133-2.617-3.636-2.39l5.894,14.478c-0.302,0.325-0.749,0.815-1.067,1.369 c-1.26-0.636-3.785-1.577-6.309-0.561c-0.848,0.341-1.565,0.844-2.173,1.452c-1.874,1.874-2.819,5.001-3.305,7.216 c-0.15,0.683-0.262,1.297-0.333,1.726c0.783-0.587,1.292-0.957,1.768-1.273c0.425-0.282,0.829-0.516,1.399-0.81 c1.029-0.53,2.431-1.101,3.693-1.101c0.68,0,1.443,0.183,1.966,0.617c0.187,0.155,1.685,2.263,4.638,3.038 c2.777,0.729,2.836,1.196,2.882,1.572c0,0-0.486,0.791-1.535,1.522c-0.567-0.868-0.913-1.305-1.441-1.856 c-1.38-1.439-3.59-2.218-5.397-2.202c-1.721,0.015-2.992,0.798-6.362,0.798c-3.415,0-5.788-0.863-7.539-1.889 c-1.258-0.686-2.165-1.544-3.014-2.231c0.449,1.097,0.886,1.965,1.28,2.847c0.29,0.632,1.361,2.78,2.701,3.95 c1.72,1.453,3.421,1.937,5.099,1.937c1.701,0,3.377-0.497,5.026-0.986c1.623-0.481,3.191-0.947,4.756-0.947 c2.03,0,3.133,0.679,4.02,1.225c-0.283,0.197-0.591,0.405-0.938,0.625c-1.254,0.796-2.247,1.091-3.216,1.091 c-1.192,0-3.338-0.623-5.211-1.372c-0.014,0.135-0.017,0.275-0.02,0.421c-0.004,0.155-0.004,0.309-0.004,0.482 c0,1.057,0.174,2.321,1.362,3.54c0.513,0.525,1.146,0.927,1.891,1.209c0.778,0.294,1.695,0.439,2.69,0.492 c-0.452,0.416-0.878,0.806-1.291,1.315c-1,1.232-1.813,2.885-1.813,5.009c0,1.092,0.194,2.005,0.465,2.879 c0.193,0.62,0.386,1.182,0.653,1.853l0.883-1.061c0.016-0.017,0.986-1.159,2.314-2.126c-0.851,1.712-1.357,3.586-1.357,5.519 c0,4.216,2.344,7.646,5.546,10.337c0,0,0.766,0.679,1.301,1.094c-0.013-0.676,0.001-1.112,0.001-1.699 c0-2.058,0.334-6.034,1.686-8.439c0.146,0.563,0.313,1.391,0.457,2.325c0.191,1.243,0.34,2.673,0.34,3.918 c0,2.068-0.298,3.595-0.651,4.695c-0.405,1.265-0.748,1.746-1.062,2.281c1.304,0.046,2.519-0.109,3.677-0.378 c2.187-0.507,4.11-1.582,5.641-3.564c0.664-0.861,1.171-1.833,1.52-2.915c0.379-1.176,0.57-2.482,0.573-3.912 c0.002-0.83-0.077-1.684-0.194-2.516c-0.032-0.225-0.079-0.498-0.102-0.67c0.23,0.186,0.391,0.358,0.584,0.579 c0.752,0.861,1.432,2.182,1.432,4.317c0,0.728-0.041,1.855-0.354,3.118c0.726-0.238,1.465-0.68,2.166-1.126 c0.851-0.541,1.659-1.183,2.388-1.912c2-2,3.378-4.655,3.408-7.69c0.02-1.977-0.401-3.563-1.333-5.41 c-0.101-0.2-0.219-0.406-0.322-0.61c0.217,0.093,0.422,0.208,0.614,0.332c1.061,0.685,1.748,1.768,2.207,2.992 c0.276,0.738,0.476,1.459,0.612,2.311C68.515,62.606,68.88,62.095,69.296,61.373z M46.139,79.961c-0.104,0-0.209-0.001-0.314-0.004 l0.054-0.091c0.276-0.46,0.59-0.981,0.945-2.089c0.435-1.357,0.655-2.945,0.655-4.72c0-1.104-0.121-2.5-0.341-3.931 c-0.136-0.882-0.303-1.732-0.459-2.333c-0.008-0.032-0.035-0.056-0.068-0.06c-0.004,0-0.007-0.001-0.011-0.001 c-0.029,0-0.056,0.016-0.07,0.041c-1.252,2.228-1.697,5.96-1.697,8.479c0,0.202-0.002,0.386-0.003,0.568 c-0.003,0.302-0.005,0.599,0,0.963c-0.513-0.409-1.157-0.979-1.164-0.986c-3.663-3.077-5.519-6.535-5.519-10.277 c0-1.837,0.454-3.681,1.349-5.482c0.017-0.033,0.008-0.074-0.02-0.098c-0.015-0.013-0.034-0.019-0.052-0.019 c-0.017,0-0.033,0.005-0.048,0.016c-1.228,0.894-2.15,1.934-2.322,2.133l-0.801,0.963c-0.223-0.568-0.405-1.09-0.601-1.72 c-0.319-1.028-0.461-1.908-0.461-2.855c0-1.823,0.604-3.491,1.795-4.958c0.397-0.489,0.807-0.867,1.241-1.268l0.042-0.038 c0.024-0.022,0.032-0.056,0.021-0.087c-0.011-0.03-0.039-0.051-0.072-0.053c-1.078-0.057-1.95-0.216-2.666-0.487 c-0.737-0.279-1.363-0.679-1.862-1.19c-1.18-1.211-1.339-2.441-1.339-3.484c0-0.173,0.001-0.325,0.004-0.48 c0.003-0.111,0.005-0.212,0.011-0.307c2.059,0.814,4.067,1.337,5.139,1.337c1.052,0,2.058-0.34,3.26-1.103 c0.306-0.194,0.606-0.393,0.941-0.627c0.022-0.016,0.035-0.041,0.035-0.069c-0.001-0.027-0.015-0.052-0.038-0.067 c-0.895-0.551-2.008-1.237-4.062-1.237c-1.577,0-3.133,0.461-4.78,0.95c-1.628,0.483-3.312,0.983-5.003,0.983 c-1.868,0-3.519-0.627-5.047-1.918c-1.394-1.218-2.476-3.481-2.679-3.922c-0.134-0.301-0.274-0.6-0.418-0.908 c-0.239-0.513-0.485-1.041-0.737-1.637c0.095,0.079,0.191,0.16,0.289,0.241c0.696,0.584,1.484,1.245,2.488,1.792 c2.179,1.277,4.658,1.899,7.577,1.899c1.991,0,3.274-0.277,4.305-0.499c0.729-0.157,1.358-0.293,2.058-0.299l0.053,0 c1.912,0,4.035,0.875,5.284,2.177c0.538,0.561,0.885,1.009,1.432,1.844c0.012,0.018,0.031,0.031,0.052,0.035 c0.005,0.001,0.01,0.002,0.015,0.002c0.016,0,0.033-0.005,0.046-0.015c1.05-0.732,1.538-1.513,1.558-1.546 c0.01-0.016,0.014-0.034,0.011-0.052c-0.049-0.4-0.109-0.897-2.942-1.641c-2.543-0.668-3.984-2.317-4.457-2.86 c-0.074-0.085-0.124-0.141-0.15-0.163c-0.487-0.404-1.222-0.635-2.018-0.635c-1.302,0-2.747,0.604-3.73,1.11 c-0.567,0.292-0.975,0.528-1.407,0.814c-0.464,0.308-0.951,0.662-1.609,1.154c0.06-0.348,0.161-0.892,0.299-1.522 c0.728-3.311,1.832-5.725,3.284-7.176c0.634-0.634,1.356-1.116,2.146-1.434c0.729-0.294,1.516-0.443,2.338-0.443 c1.587,0,3,0.544,3.904,1.001c0.012,0.006,0.024,0.009,0.037,0.009c0.028,0,0.055-0.015,0.07-0.041 c0.325-0.567,0.801-1.079,1.056-1.354c0.021-0.023,0.028-0.056,0.016-0.086l-5.855-14.38c0.089-0.01,0.18-0.014,0.271-0.014 c1.383,0,2.806,1.058,3.173,2.359c0.191,0.68,0.094,1.465-0.261,2.101c-0.02,0.036-0.01,0.081,0.023,0.105 c0.014,0.01,0.031,0.015,0.047,0.015c0.022,0,0.044-0.009,0.06-0.026c0.318-0.346,0.726-0.599,1.179-0.731 c0.236-0.069,0.478-0.104,0.721-0.104c1.157,0,2.251,0.777,2.507,1.928c0.357,1.611-0.356,2.907-1.631,3.328 c-0.337,0.099-0.526,0.143-0.748,0.143c-0.138,0-0.295-0.017-0.539-0.058c-0.004-0.001-0.009-0.001-0.013-0.001 c-0.026,0-0.052,0.013-0.067,0.035c-0.018,0.026-0.019,0.06-0.003,0.087c0.985,1.653,2.074,2.678,4.455,2.678 c2.122,0,3.605-2.009,4.777-3.974c0.02-0.033,0.013-0.075-0.015-0.101c-0.015-0.014-0.035-0.021-0.054-0.021 c-0.017,0-0.034,0.005-0.048,0.016c-0.433,0.318-0.985,0.493-1.554,0.493c-1.439,0-2.61-1.193-2.61-2.659 c0-1.467,1.171-2.66,2.61-2.66c0.466,0,0.933,0.122,1.314,0.343c0.013,0.007,0.027,0.011,0.041,0.011 c0.024,0,0.049-0.011,0.064-0.032c0.025-0.033,0.021-0.078-0.008-0.107c-0.516-0.506-0.8-1.187-0.8-1.916 c0-1.467,1.171-2.66,2.61-2.66c1.439,0,2.609,1.193,2.609,2.66c0,0.708-0.306,1.435-0.82,1.946 c-0.029,0.029-0.032,0.075-0.007,0.107c0.016,0.02,0.04,0.031,0.064,0.031c0.014,0,0.029-0.004,0.042-0.012 c0.401-0.243,0.861-0.372,1.332-0.372c1.439,0,2.61,1.193,2.61,2.66c0,1.466-1.171,2.659-2.61,2.659 c-0.555,0-1.559-0.495-1.569-0.5c-0.011-0.006-0.023-0.008-0.036-0.008c-0.022,0-0.044,0.009-0.059,0.026 c-0.024,0.026-0.029,0.066-0.01,0.096c1.098,1.841,2.635,3.955,4.792,3.955c2.35,0,3.428-1.017,4.407-2.659 c0.016-0.027,0.015-0.061-0.003-0.087c-0.015-0.022-0.04-0.035-0.067-0.035c-0.004,0-0.009,0-0.013,0.001 c-0.244,0.041-0.4,0.058-0.538,0.058c-0.223,0-0.412-0.044-0.752-0.144c-1.271-0.42-1.986-1.717-1.626-3.336 c0.254-1.142,1.348-1.919,2.505-1.919c0.243,0,0.485,0.035,0.72,0.104c0.452,0.132,0.86,0.385,1.181,0.731 c0.016,0.017,0.038,0.026,0.059,0.026c0.017,0,0.033-0.005,0.048-0.016c0.033-0.024,0.043-0.069,0.023-0.105 c-0.356-0.636-0.454-1.421-0.261-2.101c0.36-1.279,1.812-2.359,3.172-2.359c0.091,0,0.182,0.005,0.271,0.014L60.633,29.28 c-0.02,0.03-0.014,0.063,0.009,0.091c0.014,0.016,0.035,0.024,0.056,0.024c0.015,0,0.03-0.003,0.043-0.01 c1.799-0.841,3.489-1.268,5.023-1.268c0.629,0,1.225,0.07,1.817,0.214c-0.519,2.088-1.314,4.504-3.226,6.676 c-0.017,0.019-0.023,0.044-0.019,0.068s0.02,0.045,0.042,0.057l0.033,0.017c4.622,2.405,6.635,6.096,6.73,12.34l-0.006,0.204 c-0.003,0.121-0.006,0.22-0.014,0.344c-0.082-0.167-0.186-0.379-0.266-0.531c-0.442-0.842-0.851-1.429-1.325-1.903 c-0.692-0.692-1.601-1.173-2.558-1.353c-0.134-0.025-0.265-0.046-0.407-0.058c-0.002,0-0.005,0-0.007,0 c-0.033,0-0.063,0.02-0.075,0.051c-0.013,0.033-0.003,0.071,0.025,0.093c0.097,0.076,0.19,0.156,0.278,0.236 c1.428,1.254,2.518,2.848,3.241,4.739c0.614,1.606,0.912,3.307,0.912,5.2c0,2.553-0.577,4.848-1.714,6.82 c-0.333,0.578-0.654,1.057-0.975,1.459c-0.13-0.75-0.313-1.42-0.587-2.15c-0.528-1.408-1.26-2.399-2.239-3.031 c-0.216-0.14-0.421-0.25-0.626-0.338c-0.01-0.004-0.021-0.007-0.032-0.007c-0.022,0-0.043,0.009-0.059,0.025 c-0.023,0.025-0.029,0.062-0.013,0.092c0.052,0.102,0.107,0.204,0.162,0.306c0.055,0.102,0.11,0.204,0.16,0.304 c0.959,1.901,1.343,3.458,1.324,5.373c-0.027,2.767-1.229,5.478-3.384,7.633c-0.711,0.711-1.51,1.35-2.374,1.901 c-0.609,0.387-1.311,0.817-2.009,1.07c0.216-0.925,0.322-1.906,0.322-2.993c0-1.797-0.489-3.268-1.452-4.37 c-0.204-0.234-0.367-0.405-0.595-0.589c-0.014-0.012-0.032-0.018-0.051-0.018c-0.014,0-0.027,0.003-0.04,0.01 c-0.029,0.016-0.045,0.049-0.041,0.081c0.012,0.086,0.029,0.196,0.048,0.313c0.019,0.119,0.039,0.244,0.054,0.357 c0.132,0.936,0.195,1.756,0.194,2.505c-0.003,1.416-0.194,2.724-0.569,3.887c-0.344,1.068-0.851,2.041-1.507,2.891 c-1.417,1.833-3.247,2.99-5.595,3.534C48.23,79.835,47.182,79.961,46.139,79.961z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "outer_contrast_line_1_",
    cx: 24.7676,
    cy: 24.0412,
    r: 80.3513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#414243"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#3F3F40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#3C3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8105,
    style: {
      stopColor: "#393A3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8489,
    style: {
      stopColor: "#2F3032"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#212226"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9023,
    style: {
      stopColor: "#1F1F1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9355,
    style: {
      stopColor: "#19170A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#181607"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9709,
    style: {
      stopColor: "#0E0802"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090100"
    }
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "outer_contrast_line_6_",
    fill: "url(#outer_contrast_line_1_)",
    d: "M100,33.401c-2.024-9.633-6.804-18.557-13.87-25.623 c-0.658-0.658-1.334-1.294-2.023-1.912c-2.981,0.77-5.993,1.436-9.028,2.004C67.769,2.782,59.028,0,50,0 c-9.028,0-17.769,2.782-25.079,7.869c-3.035-0.568-6.047-1.234-9.028-2.004c-0.689,0.618-1.365,1.254-2.023,1.912 C6.804,14.844,2.024,23.768,0,33.401c2.158,2.197,4.241,4.472,6.251,6.817c-0.103,1.223-0.158,2.453-0.158,3.69 c0,11.645,4.626,22.813,12.86,31.047c3.626,3.626,7.821,6.551,12.375,8.691c1.026,2.913,1.955,5.854,2.779,8.821 C39.191,94.13,44.55,95.003,50,95.003c5.45,0,10.809-0.872,15.894-2.537c0.824-2.967,1.753-5.908,2.779-8.821 c4.554-2.14,8.749-5.065,12.375-8.691c8.234-8.234,12.86-19.402,12.86-31.047c0-1.236-0.055-2.467-0.158-3.689 C95.759,37.873,97.842,35.598,100,33.401z M93.665,40.191c0.105,1.232,0.161,2.471,0.161,3.717c0,11.623-4.617,22.771-12.836,30.99 c-3.627,3.627-7.825,6.552-12.383,8.689c-1.026,2.911-1.955,5.851-2.78,8.816c-5.064,1.653-10.401,2.52-15.827,2.52 c-5.427,0-10.763-0.867-15.827-2.519c-0.825-2.965-1.754-5.905-2.78-8.816c-4.557-2.137-8.755-5.062-12.383-8.689 c-8.219-8.219-12.836-19.366-12.836-30.99c0-1.246,0.056-2.485,0.161-3.717c-2.009-2.344-4.09-4.619-6.246-6.816 c2.026-9.601,6.794-18.495,13.839-25.54c0.647-0.647,1.31-1.272,1.987-1.88c2.98,0.769,5.991,1.434,9.025,2.001 C32.241,2.865,40.977,0.081,50,0.081c9.023,0,17.759,2.784,25.061,7.874c3.034-0.567,6.044-1.232,9.025-2.001 c0.677,0.608,1.34,1.234,1.987,1.88c7.045,7.045,11.813,15.939,13.839,25.54C97.756,35.572,95.674,37.847,93.665,40.191z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "silver__x28_linear_gradient_x29_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.803,
    y1: 66.3435,
    x2: 3.9664,
    y2: 21.079
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#55564F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0911,
    style: {
      stopColor: "#60625F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1803,
    style: {
      stopColor: "#717576"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2529,
    style: {
      stopColor: "#81898C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3154,
    style: {
      stopColor: "#93999B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3611,
    style: {
      stopColor: "#9BA3A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    style: {
      stopColor: "#A8AEB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    style: {
      stopColor: "#BDC0BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5335,
    style: {
      stopColor: "#D0D1CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5901,
    style: {
      stopColor: "#DDDFDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6654,
    style: {
      stopColor: "#E1E4E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7306,
    style: {
      stopColor: "#E8EBEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8241,
    style: {
      stopColor: "#F1F3F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9056,
    style: {
      stopColor: "#F4F6F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6F7F7"
    }
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_96_)",
    d: "M93.551,39.993c-0.032,0.037-0.048,0.086-0.044,0.136c0.109,1.252,0.167,2.512,0.167,3.778 c0,11.583-4.601,22.692-12.792,30.883c-3.632,3.632-7.84,6.557-12.407,8.689c-0.045,0.021-0.079,0.059-0.096,0.106 c-1.018,2.892-1.94,5.811-2.759,8.756c-5.002,1.613-10.268,2.46-15.621,2.46c-5.354,0-10.619-0.847-15.621-2.46 c-0.819-2.945-1.741-5.865-2.759-8.756c-0.016-0.047-0.051-0.085-0.096-0.106c-4.567-2.132-8.774-5.056-12.407-8.689 C10.926,66.599,6.325,55.491,6.325,43.907c0-1.266,0.058-2.527,0.167-3.778c0.004-0.049-0.011-0.098-0.044-0.136 c-1.996-2.327-4.064-4.585-6.205-6.767c2.042-9.512,6.784-18.32,13.769-25.306c0.603-0.603,1.219-1.189,1.848-1.758 c2.959,0.763,5.948,1.425,8.96,1.989c0.05,0.009,0.101-0.002,0.143-0.031C32.253,3.021,40.982,0.233,50,0.233 c9.018,0,17.748,2.789,25.038,7.89c0.04,0.028,0.09,0.039,0.139,0.03c3.013-0.565,6.002-1.226,8.962-1.99 c0.629,0.569,1.246,1.155,1.848,1.758c6.986,6.986,11.727,15.794,13.769,25.306C97.615,35.408,95.547,37.667,93.551,39.993z  M77.73,9.585c-0.105,0.021-0.188,0.101-0.214,0.205c-0.026,0.104,0.011,0.213,0.094,0.281c1.135,0.925,2.228,1.909,3.272,2.954 c6.525,6.525,10.771,14.902,12.229,23.895c0.017,0.105,0.093,0.19,0.194,0.22c0.102,0.03,0.212-0.002,0.282-0.081 c1.281-1.446,2.59-2.865,3.928-4.254c0.104-0.108,0.146-0.262,0.111-0.408c-2.1-8.688-6.553-16.713-12.977-23.138 c-0.284-0.284-0.573-0.564-0.864-0.84c-0.109-0.103-0.263-0.144-0.408-0.108C81.505,8.775,79.622,9.199,77.73,9.585z  M79.566,14.341c-1.478-1.478-3.057-2.833-4.718-4.06c-0.097-0.072-0.22-0.1-0.339-0.079C66.474,11.646,58.276,12.39,50,12.39 c-8.276,0-16.474-0.744-24.509-2.188c-0.119-0.021-0.242,0.007-0.339,0.079c-1.661,1.227-3.24,2.582-4.718,4.06 C13.71,21.065,9.515,29.843,8.455,39.2c-0.014,0.123,0.024,0.247,0.104,0.342c5.266,6.235,10.008,12.961,14.144,20.126 c4.137,7.165,7.591,14.636,10.358,22.314c0.042,0.116,0.13,0.21,0.243,0.259C38.522,84.514,44.199,85.72,50,85.72 c5.801,0,11.478-1.206,16.696-3.479c0.113-0.049,0.201-0.143,0.243-0.259c2.767-7.678,6.221-15.148,10.358-22.314 c4.137-7.165,8.878-13.891,14.144-20.126c0.08-0.095,0.118-0.219,0.104-0.342C90.484,29.843,86.29,21.065,79.566,14.341z  M28.343,8.142c-0.125,0.076-0.19,0.222-0.162,0.365c0.028,0.144,0.143,0.255,0.287,0.278c7.077,1.13,14.274,1.711,21.531,1.711 c7.258,0,14.456-0.582,21.533-1.712c0.144-0.023,0.259-0.134,0.287-0.277c0.028-0.143-0.037-0.289-0.161-0.364 C65.18,4.219,57.7,2.095,50,2.095C42.301,2.095,34.822,4.219,28.343,8.142z M6.413,37.058c0.07,0.079,0.18,0.111,0.282,0.082 c0.102-0.03,0.177-0.115,0.194-0.22c1.458-8.993,5.704-17.37,12.229-23.895c1.046-1.046,2.141-2.032,3.278-2.958 c0.082-0.067,0.118-0.175,0.093-0.278s-0.108-0.181-0.211-0.203c-1.895-0.387-3.78-0.811-5.654-1.276 c-0.145-0.036-0.3,0.005-0.408,0.108c-0.291,0.276-0.58,0.556-0.864,0.84C8.927,15.683,4.474,23.708,2.374,32.396 c-0.035,0.146,0.006,0.3,0.111,0.408C3.823,34.193,5.132,35.612,6.413,37.058z M29.861,80.547c0.127,0.07,0.283,0.053,0.392-0.042 c0.109-0.095,0.147-0.248,0.095-0.383c-2.561-6.695-5.656-13.22-9.285-19.507c-3.628-6.284-7.73-12.223-12.247-17.784 c-0.092-0.113-0.245-0.157-0.383-0.11s-0.233,0.176-0.236,0.322c-0.007,0.288-0.01,0.576-0.01,0.865 c0,11.089,4.405,21.725,12.247,29.566C23.251,76.291,26.431,78.662,29.861,80.547z M65.862,85.08 c0.034-0.101,0.006-0.213-0.071-0.286s-0.189-0.097-0.289-0.059C60.596,86.598,55.349,87.582,50,87.582 c-5.349,0-10.596-0.984-15.502-2.847c-0.1-0.038-0.212-0.015-0.289,0.059c-0.077,0.074-0.105,0.185-0.071,0.286 c0.612,1.833,1.186,3.676,1.72,5.53c0.042,0.145,0.154,0.258,0.299,0.3c4.456,1.312,9.114,1.998,13.842,1.998 c4.729,0,9.387-0.685,13.842-1.998c0.144-0.042,0.257-0.156,0.299-0.3C64.675,88.756,65.249,86.913,65.862,85.08z M91.802,43.032 c-0.003-0.144-0.096-0.271-0.233-0.318s-0.288-0.003-0.379,0.109c-4.519,5.564-8.624,11.506-12.254,17.793 c-3.63,6.288-6.726,12.815-9.287,19.512c-0.051,0.134-0.013,0.286,0.095,0.381c0.108,0.094,0.264,0.111,0.39,0.042 c3.432-1.885,6.613-4.258,9.432-7.076c7.841-7.841,12.247-18.477,12.247-29.566C91.813,43.615,91.809,43.323,91.802,43.032z  M43.187,29.908c0.019-0.012,0.041-0.018,0.063-0.018c17.388,0.001,15.77-0.004,16.216,0.013c0.053,0.002,0.099,0.038,0.113,0.089 c0.014,0.051-0.007,0.105-0.051,0.134c-1.658,1.07-2.719,2.267-3.005,2.609l0.706,0.559c2.097-2.569,5.318-4.16,8.434-4.16h0.613 c0.039,0,0.076,0.019,0.099,0.05c0.023,0.032,0.029,0.073,0.017,0.11l-0.196,0.58c-0.631,1.87-2.617,6.319-7.474,7.471l0.183,0.89 c2.08-0.41,3.362-1.33,4.437-2.265c0.022-0.019,0.051-0.03,0.08-0.03c0.018,0,0.036,0.004,0.053,0.012 c3.179,1.551,5.246,4.117,5.978,7.42c0.049,0.216,0.1,0.438,0.144,0.656c0.011,0.055-0.016,0.11-0.066,0.134 c-0.053,0.025-0.111,0.009-0.146-0.033c-0.115-0.14-0.371-0.349-0.444-0.394c-0.844-0.521-1.831-0.786-2.931-0.786 c-0.939,0-1.766,0.196-2.268,0.349c0.707,0.608,1.285,1.14,1.808,1.663c1.724,1.723,2.84,3.372,3.513,5.189 c0.509,1.374,0.756,2.816,0.756,4.409c0,1.695-0.301,3.25-0.896,4.623c-0.063,0.147-0.168,0.389-0.213,0.519 c-0.017,0.049-0.063,0.082-0.115,0.082c-0.002,0-0.004,0-0.006,0c-0.054-0.002-0.099-0.04-0.112-0.093 c-0.04-0.163-0.105-0.349-0.176-0.498c-1.394-2.948-3.718-3.567-5.423-3.567c-0.181,0-0.36,0.007-0.554,0.02 c1.165,1.796,2.841,4.46,2.841,7.727c0,2.37-0.943,4.721-2.923,6.701c-1.11,1.111-1.565,1.309-2.08,1.697 c-0.041,0.032-0.102,0.034-0.146,0c-0.043-0.033-0.06-0.09-0.04-0.141c0.039-0.098,0.074-0.332,0.078-0.461 c0.094-3.586-1.867-6.482-5.013-7.434c0.375,1.521,0.804,3.215,0.804,5.527c0,2.455-0.61,4.493-1.815,6.058 c-1.383,1.799-3.663,2.946-5.663,3.276l-0.45,0.074c-0.007,0.001-0.013,0.001-0.019,0.001c-0.043,0-0.083-0.022-0.105-0.06 c-0.025-0.043-0.021-0.098,0.01-0.137c0.033-0.041,0.125-0.24,0.159-0.315c0.102-0.223,0.176-0.476,0.23-0.675 c0.511-1.885,0.526-4.166,0.526-4.42c0-3.208-0.674-5.961-1.458-8.869c-0.336,0.263-0.529,0.46-0.807,0.743 c-1.077,1.077-1.864,2.971-2.34,5.63c-0.159,0.889-0.326,2.255-0.356,3.536c-0.001,0.05-0.032,0.094-0.079,0.111 c-0.045,0.017-0.098,0.005-0.132-0.032c0,0-0.296-0.327-0.373-0.404c-1.636-1.652-2.991-3.6-3.564-5.872 c-0.195-0.774-0.294-1.57-0.294-2.366c0-3.02,1.211-5.841,3.6-8.391c-0.001,0-0.003,0.001-0.004,0.001 c-2.165,0.419-3.796,1.176-5.782,3.162c-0.07,0.07-0.299,0.322-0.299,0.322c-0.03,0.033-0.076,0.047-0.121,0.035 c-0.044-0.012-0.078-0.047-0.087-0.092c-0.136-0.638-0.257-1.459-0.257-2.103c0-1.871,0.711-3.53,2.112-4.932 c1.3-1.3,2.294-1.734,5.367-3.013c-1.946,0.266-2.836,0.428-4.609,0.428c-2.222,0-3.759-0.456-4.698-1.395 c-0.265-0.265-0.533-0.601-0.85-1.291c-0.043-0.093-0.138-0.318-0.177-0.429c-0.016-0.045-0.004-0.095,0.031-0.128 c0.034-0.032,0.083-0.043,0.13-0.024c0.1,0.041,1.014,0.373,1.124,0.409c0.225,0.073,0.483,0.15,0.703,0.208 c0.753,0.197,1.391,0.289,2.009,0.289c1.819,0,3.298-0.801,5.097-2.093c0.754-0.542,1.389-1.069,1.887-1.567 c0.795-0.795,0.889-1.159,0.89-1.162c-0.034-1.058-0.066-2.072-3.875-3.072c-2.145-0.563-3.304-1.867-3.861-2.494 c-0.104-0.117-0.202-0.228-0.252-0.268c-0.753-0.616-1.682-0.929-2.763-0.929c-0.801,0-1.676,0.177-2.675,0.541 c-0.553,0.202-1.001,0.398-1.634,0.691l-0.449,0.207c-0.043,0.019-0.094,0.013-0.131-0.019c-0.036-0.032-0.05-0.082-0.036-0.127 l0.147-0.472c0.171-0.55,0.357-1.056,0.603-1.64c0.209-0.497,0.424-0.929,0.657-1.322c0.783-1.317,1.751-2.216,2.878-2.673 c0.588-0.238,1.23-0.359,1.907-0.359c1.65,0,3.142,0.729,3.707,1.043c0.038,0.021,0.062,0.061,0.062,0.104 c0.038,2.677,1.582,4.547,3.754,4.547c1.024,0,1.823-0.342,2.59-1.109c0.4-0.4,0.725-0.887,0.992-1.486 c0.157-0.352,0.274-0.615,0.286-0.794c0.002-0.037,0.022-0.07,0.052-0.091c0.021-0.014,0.045-0.022,0.069-0.022 c0.012,0,0.023,0.002,0.034,0.005c0.278,0.081,0.605,0.258,0.867,0.504l0.805-0.717c-0.78-0.78-2.123-1.382-3.706-1.382 c-0.49,0-0.866,0.054-1.21,0.11c-1,0.162-2.13,0.441-3.216-0.193c-0.028-0.016-0.048-0.043-0.056-0.074 c-0.008-0.031-0.003-0.064,0.013-0.092C41.398,31.409,42.255,30.483,43.187,29.908z M27.876,45.329 c-1.794,0-3.41-0.668-4.673-1.932c-0.666-0.666-1.261-1.286-1.78-2.454c-0.022-0.049-0.009-0.106,0.031-0.141 c0.041-0.035,0.099-0.039,0.144-0.011c0.353,0.225,0.824,0.543,1.501,0.823c1.789,0.741,3.468,1.159,6.166,1.159 c2.996,0,5.265-0.898,6.559-0.898c1.914,0,2.697,0.502,4.131,1.673c0.044,0.036,0.057,0.098,0.032,0.148 c-0.026,0.051-0.083,0.077-0.138,0.063c-1.165-0.295-2.594-0.394-3.889-0.202c-1.16,0.172-2.173,0.473-3.245,0.791 C31.061,44.839,29.462,45.329,27.876,45.329z M43.371,36.673c-1.428,0-2.474-1.197-2.74-2.621L40.546,33.6 c-0.008-0.041,0.007-0.083,0.037-0.112c0.023-0.021,0.052-0.032,0.082-0.032c0.028,0,0.581,0.157,0.608,0.164 c0.333,0.093,0.672,0.146,0.998,0.194c0.05,0.007,0.09,0.045,0.101,0.094c0.061,0.274,0.099,0.49,0.297,0.688 c0.216,0.216,0.503,0.335,0.81,0.335c0.636,0,1.113-0.505,1.141-1.073l0.01-0.198c0.003-0.062,0.053-0.112,0.115-0.115 c0.801-0.041,0.947-0.02,1.613,0.022c0.036,0.002,0.069,0.021,0.09,0.05c0.021,0.029,0.028,0.066,0.02,0.101 c-0.174,0.684-0.356,1.42-1.057,2.119C44.673,36.574,43.966,36.673,43.371,36.673z M50.187,57.478l0.249-0.035 c0.667-0.095,1.335-0.232,1.986-0.408c1.246-0.337,3.061-1.034,4.421-3.184c0.409-0.647,0.701-1.322,0.894-2.066 c0.19-0.733,0.282-1.532,0.282-2.442c0-0.135-0.005-0.277-0.013-0.422c-0.003-0.056,0.033-0.107,0.087-0.123 c0.011-0.003,0.023-0.005,0.034-0.005c0.043,0,0.083,0.022,0.105,0.061c0.125,0.219,0.243,0.465,0.35,0.731 c0.232,0.576,0.384,1.227,0.465,1.99c0.05,0.474,0.073,0.989,0.073,1.619v0.125c0,0.606,0.001,1.178-0.047,1.828l-0.02,0.282 l0.191-0.209c0.555-0.607,1.153-1.303,1.766-2.271c1.108-1.752,1.671-3.662,1.671-5.678c0-0.884-0.098-1.692-0.299-2.47 c-0.281-1.088-0.765-2.11-1.478-3.124c-0.433-0.615-0.873-1.146-1.379-1.663l-0.473,1.478c0.335,0.394,0.588,0.758,0.8,1.071 c0.613,0.903,1.001,1.729,1.221,2.598c0.212,0.843,0.241,1.652,0.241,2.401c0,0.6-0.065,1.206-0.195,1.799 c-0.097,0.445-0.234,0.915-0.331,1.23c-0.103,0.332-0.323,0.925-0.333,0.95c-0.018,0.048-0.064,0.079-0.114,0.079 c-0.006,0-0.012,0-0.019-0.001c-0.057-0.009-0.1-0.057-0.103-0.114c0-0.007-0.032-0.686-0.093-1.047l-0.029-0.171 c-0.052-0.317-0.106-0.645-0.188-0.913c-0.3-0.978-0.785-1.807-1.442-2.464c-0.408-0.407-0.888-0.756-1.43-1.036 c-0.313-0.162-0.62-0.296-0.95-0.413c0.074,0.287,0.151,0.6,0.234,0.958c0.268,1.157,0.393,2.112,0.393,3.006 c0,1.426-0.322,2.634-0.986,3.693c-0.225,0.359-0.493,0.694-0.795,0.996L54.9,54.148c-0.274,0.274-0.51,0.51-0.784,0.722 c-0.355,0.276-0.514,0.389-0.811,0.576c-0.045,0.029-0.108,0.025-0.15-0.016c-0.04-0.04-0.048-0.101-0.019-0.15 c0.149-0.248,0.281-0.528,0.407-0.792c0.172-0.359,0.28-0.737,0.359-1.013c0.759-2.68-0.499-4.336-1.511-5.348 c-0.079-0.08-0.157-0.155-0.234-0.228c-0.013,0.297-0.027,0.595-0.048,0.895c-0.093,1.347-0.342,2.879-1.49,4.027 c-0.139,0.139-0.349,0.349-0.604,0.56c-0.217,0.179-0.464,0.383-0.793,0.586c-0.046,0.029-0.106,0.022-0.146-0.014 c-0.04-0.037-0.05-0.096-0.025-0.145c0.043-0.082,0.083-0.152,0.124-0.224c0.094-0.162,0.191-0.33,0.33-0.679 c0.23-0.574,0.278-1.093,0.278-1.428c0-0.54-0.115-0.967-0.216-1.278c-0.037-0.115-0.079-0.226-0.125-0.331l-1.21,0.651 c0.024,0.079,0.047,0.159,0.066,0.233c0.079,0.309,0.119,0.595,0.119,0.85c0,0.572-0.161,1.111-0.493,1.649 c-0.211,0.342-0.487,0.678-0.867,1.059c-0.327,0.327-0.675,0.639-0.983,0.914l-0.414,0.373l0.259-0.003 c0.623-0.007,1.451-0.035,2.327-0.192c1.391-0.25,2.477-0.783,3.322-1.628c0.339-0.339,0.639-0.733,0.893-1.172 c0.028-0.049,0.087-0.072,0.142-0.055c0.054,0.017,0.089,0.07,0.084,0.127c-0.043,0.468-0.161,0.942-0.362,1.449 c-0.227,0.575-0.556,1.176-1.006,1.838c-0.271,0.399-0.576,0.835-0.973,1.321L50.187,57.478z M50.124,43.222 c0.177-0.049,0.349-0.108,0.514-0.177c-0.02,0.001-0.04,0.001-0.06,0.001c-1.131,0-1.85-0.655-2.546-1.288 c-0.656-0.597-1.276-1.162-2.207-1.162c-0.131,0-0.259,0.012-0.384,0.037c0.733,0.159,1.036,0.465,1.43,0.862l0.089,0.089 c0.14,0.14,0.276,0.286,0.412,0.431c0.132,0.141,0.263,0.282,0.396,0.416c0.514,0.514,0.939,0.877,1.73,0.877 C49.696,43.308,49.907,43.279,50.124,43.222z M59.43,34.949c0.993-0.231,1.908-0.758,2.719-1.57 c0.871-0.871,1.284-1.55,1.432-1.917c-2.213,0.368-4.229,2.176-4.602,2.526L59.43,34.949z M49.309,79.429 c2.313-0.536,4.114-1.674,5.509-3.479c0.645-0.836,1.143-1.793,1.482-2.844c1.013-3.146,0.362-6.275,0.267-6.996 c-0.013-0.095,0.033-0.187,0.116-0.234c0.082-0.047,0.187-0.038,0.261,0.022c0.236,0.191,0.404,0.367,0.613,0.607 c0.989,1.132,1.49,2.636,1.49,4.471c0,0.99-0.086,1.893-0.264,2.747c0.887-0.374,2.66-1.426,4.066-2.832 c2.127-2.127,3.313-4.8,3.34-7.527c0.028-2.805-0.869-4.407-1.63-5.912c-0.044-0.087-0.029-0.193,0.038-0.265 c0.065-0.069,0.168-0.094,0.261-0.055c1.464,0.627,2.383,1.952,2.947,3.456c0.236,0.628,0.405,1.213,0.532,1.84 c0.249-0.339,0.502-0.731,0.756-1.171c1.124-1.949,1.694-4.218,1.694-6.744c0-3.781-1.323-7.384-4.103-9.827 c-0.085-0.077-0.176-0.155-0.27-0.229c-0.081-0.064-0.111-0.173-0.073-0.269c0.035-0.09,0.122-0.148,0.217-0.148 c0.088,0,0.352,0.044,0.442,0.061c0.987,0.185,1.923,0.681,2.637,1.395c0.485,0.485,0.901,1.082,1.35,1.937 c-0.097-5.644-1.73-9.594-6.68-12.165c-0.064-0.033-0.108-0.094-0.121-0.164c-0.013-0.07,0.007-0.143,0.054-0.197 c1.845-2.096,2.64-4.427,3.155-6.462c-0.531-0.118-1.067-0.175-1.631-0.175c-1.511,0-3.179,0.422-4.958,1.253 c-0.093,0.044-0.206,0.02-0.275-0.059c-0.059-0.068-0.072-0.162-0.038-0.243l5.377-13.26c-1.314-0.027-2.73,1.014-3.076,2.248 c-0.182,0.642-0.089,1.384,0.248,1.985c0.058,0.103,0.029,0.233-0.066,0.302c-0.097,0.07-0.229,0.056-0.308-0.03 c-0.464-0.502-1.116-0.786-1.79-0.786c-1.089,0-2.119,0.732-2.355,1.791c-0.343,1.541,0.329,2.772,1.519,3.166 c0.53,0.155,0.676,0.174,1.223,0.082c0.095-0.015,0.182,0.027,0.231,0.098c0.051,0.075,0.054,0.173,0.008,0.251 c-1.006,1.687-2.116,2.733-4.538,2.733c-2.234,0-3.805-2.153-4.923-4.029c-0.053-0.089-0.041-0.202,0.029-0.278 c0.071-0.076,0.183-0.096,0.275-0.05c0.271,0.135,1.07,0.484,1.501,0.484c1.356,0,2.458-1.125,2.458-2.507 c0-1.383-1.103-2.508-2.458-2.508c-0.442,0-0.875,0.121-1.253,0.35c-0.1,0.061-0.231,0.038-0.305-0.056 c-0.073-0.093-0.064-0.226,0.019-0.309c0.485-0.482,0.775-1.17,0.775-1.838c0-1.383-1.102-2.508-2.457-2.508 c-1.355,0-2.458,1.125-2.458,2.508c0,0.688,0.268,1.33,0.754,1.808c0.084,0.082,0.093,0.214,0.022,0.307 c-0.07,0.092-0.199,0.12-0.302,0.06c-0.359-0.208-0.798-0.323-1.238-0.323c-1.355,0-2.458,1.125-2.458,2.508 c0,1.383,1.103,2.507,2.458,2.507c0.537,0,1.056-0.165,1.464-0.464c0.089-0.066,0.212-0.059,0.295,0.015 c0.082,0.075,0.1,0.197,0.043,0.292c-1.193,2.002-2.709,4.048-4.908,4.048c-2.445,0-3.601-1.1-4.585-2.752 c-0.047-0.078-0.043-0.176,0.008-0.251c0.049-0.072,0.136-0.113,0.231-0.098c0.551,0.093,0.696,0.072,1.214-0.08 c1.199-0.396,1.868-1.626,1.533-3.143c-0.24-1.085-1.271-1.817-2.36-1.817c-0.228,0-0.456,0.033-0.678,0.098 c-0.426,0.124-0.81,0.362-1.109,0.688c-0.08,0.087-0.213,0.1-0.308,0.031c-0.096-0.069-0.125-0.199-0.067-0.302 c0.335-0.601,0.428-1.343,0.247-1.986c-0.348-1.234-1.766-2.275-3.077-2.248l5.775,14.185c0.034,0.084,0.017,0.18-0.045,0.246 c-0.251,0.271-0.719,0.775-1.036,1.327c-0.043,0.075-0.121,0.117-0.202,0.117c-0.035,0-0.071-0.008-0.105-0.025 c-0.89-0.449-2.278-0.984-3.836-0.984c-0.802,0-1.57,0.145-2.281,0.432c-0.772,0.31-1.477,0.782-2.096,1.4 c-1.43,1.43-2.521,3.82-3.243,7.101c-0.095,0.432-0.172,0.823-0.23,1.138c0.51-0.378,0.917-0.67,1.308-0.93 c0.437-0.29,0.848-0.528,1.421-0.823c0.998-0.514,2.468-1.127,3.8-1.127c0.83,0,1.601,0.244,2.115,0.671 c0.029,0.024,0.086,0.086,0.168,0.18c0.466,0.533,1.884,2.157,4.381,2.813c2.717,0.713,2.985,1.203,3.054,1.77 c0.006,0.052-0.005,0.105-0.033,0.15c-0.021,0.034-0.524,0.841-1.6,1.591c-0.039,0.027-0.086,0.042-0.133,0.042 c-0.076,0-0.151-0.038-0.195-0.106c-0.547-0.836-0.877-1.262-1.414-1.822c-1.222-1.274-3.302-2.131-5.174-2.131 c-1.752,0.012-3.013,0.799-6.417,0.799c-2.947,0-5.451-0.628-7.65-1.917c-0.919-0.501-1.656-1.094-2.307-1.638 c0.849,1.907,1.964,4.448,3.536,5.821c1.499,1.266,3.118,1.882,4.948,1.882c3.312,0,6.559-1.933,9.782-1.933 c2.098,0,3.231,0.698,4.142,1.26c0.067,0.041,0.109,0.113,0.111,0.192s-0.035,0.153-0.1,0.198 c-1.352,0.942-2.648,1.757-4.288,1.757c-1.264,0-3.412-0.659-4.996-1.27c-0.027,1.183-0.052,2.569,1.289,3.946 c0.483,0.495,1.091,0.883,1.807,1.153c0.701,0.265,1.558,0.421,2.62,0.477c0.094,0.005,0.175,0.065,0.207,0.154 c0.032,0.088,0.008,0.187-0.061,0.25c-0.46,0.424-0.873,0.803-1.268,1.29c-1.168,1.439-1.761,3.075-1.761,4.862 c0,1.004,0.135,2.113,0.959,4.279l0.638-0.767c0.174-0.201,1.106-1.252,2.348-2.156c0.088-0.064,0.207-0.057,0.287,0.01 c0.082,0.069,0.106,0.186,0.058,0.282c-0.885,1.78-1.333,3.602-1.333,5.415c0,3.695,1.838,7.113,5.468,10.163 c0.006,0.005,0.461,0.408,0.908,0.778c-0.001-0.419,0.006-0.781,0.006-1.209c0-2.538,0.45-6.3,1.716-8.553 c0.102-0.182,0.376-0.148,0.429,0.055c0.157,0.606,0.325,1.461,0.462,2.348c0.538,3.499,0.613,7.665-1.197,10.706 C47.116,79.809,48.134,79.702,49.309,79.429z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScaniaSymbol);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scania-symbol.2a6aceb11c5860488af2e7fa6a845547.svg";